SJ.on.preload(() => {
	SJ.ScreensManager = {};

	SJ.ScreensManager._isSetupped = false;

	SJ.ScreensManager.screens = {
		mainMenu: {},
		selectLocation: {},
		selectTournament: {},
		shop: {},
		howToPlay: {},
		game: {},
		settings: {},
		rank: {},
		jumpsRank: {},
		tournamentRank: {},
		career: {},
		careerBestJumps: {},
		itemUpgrade: {},
		vipClub: {},
		fameGallery: {},
		bank: {},
		playground: {},
	};

	SJ.ScreensManager.setup = () => {
		SJ.viewsSpriteSheets = {};

		if (SJ.ScreensManager._isSetupped) {
			SJ.ScreensManager.currentScreen = SJ.ScreensManager.screens.mainMenu;
			return;
		}

		const backBtn = new SJ.Button(
			'Wróć',
			20,
			SJ.SCREEN_HEIGHT - 60,
			200,
			40,
			null,
			() => {
				SJ.ScreensManager.changeScreen(SJ.ScreensManager.screens.mainMenu);
			}
		);

		const backToMenuSS = new SJ.AnimatedSpriteSheet(
			'./UI/menu-btn/menu-btn.png',
			0,
			0,
			1600,
			171,
			67,
			18,
			true,
			false,
			true,
			() => setInterval(() => backToMenuSS.animation.restart(), 3200)
		);

		const bankSS = SJ.ImageLoader.load('UI/bank/bankSS.png');

		const BackToMenuBtn = class extends SJ.TextureButton {
			constructor(x, y) {
				const backToMenu = backToMenuSS;

				super(x - 10, y, null, backToMenu, null, null, null, null, () =>
					SJ.ScreensManager.changeScreen(SJ.ScreensManager.screens.mainMenu)
				);

				this.w = 171;
				this.h = 67;
			}
		};

		const VIPshopButton = new SJ.Button(
			`Sklep VIP`,
			SJ.SCREEN_WIDTH - 170,
			100,
			140,
			25,
			() => {
				SJ.ScreensManager.changeScreen(SJ.ScreensManager.screens.bank);
				SJ.mainMenuSoundContainer.play('bank');
			}
		);

		const VIPclubButton = new SJ.Button(
			`Klub VIP`,
			SJ.SCREEN_WIDTH - 170,
			135,
			140,
			25,
			() => {
				SJ.ScreensManager.changeScreen(SJ.ScreensManager.screens.vipClub);
				SJ.mainMenuSoundContainer.play('VIPClub');
			}
		);

		const guestTutorialsSS = SJ.ImageLoader.load(
			'UI/tutorial/guest_tutorials.png'
		);

		SJ.userDataBarSS = SJ.ImageLoader.load(
			'UI/user-data-info-bar/userDataBarSS.png'
		);
		SJ.vipClubSS = SJ.ImageLoader.load('UI/vip-club/vipClubSS.png');
		SJ.fameGallerySS = SJ.ImageLoader.load('UI/fame-gallery/fameGallery.png');
		SJ.fameGallerySS2 = SJ.ImageLoader.load('UI/fame-gallery/fameGallery2.png');
		SJ.viewsSpriteSheets.gameSS = SJ.ImageLoader.load(
			'UI/jump-screen/gameSS.png'
		);
		SJ.viewsSpriteSheets.gameSS2 = SJ.ImageLoader.load(
			'UI/jump-screen/gameSS2.png'
		);

		SJ.userDataBar = new SJ.UserDataBar();

		SJ.registration = new SJ.Registration();

		SJ.registrationTutorial = new SJ.RegistrationTutorial(guestTutorialsSS);
		SJ.demoTutorial = new SJ.DemoTutorial(guestTutorialsSS);

		if (SJ.playerData.data['name'] !== 'Guest') {
			const newspaperSS = SJ.ImageLoader.load('UI/tutorial/newspaper.png');
			const userTutorialsSS = SJ.ImageLoader.load(
				'UI/tutorial/user_tutorials.png'
			);

			SJ.newUserTutorial = new SJ.NewUserTutorial(newspaperSS);
			SJ.tutorial1 = new SJ.Tutorial1(userTutorialsSS);
			SJ.tutorial2 = new SJ.Tutorial2(userTutorialsSS);
			SJ.tutorial3 = new SJ.Tutorial3(userTutorialsSS);
			SJ.tutorial4 = new SJ.Tutorial4(userTutorialsSS);
			SJ.tutorial5 = new SJ.Tutorial5(userTutorialsSS);
			SJ.tutorial6 = new SJ.Tutorial6(userTutorialsSS);
			SJ.tutorialEnd = new SJ.TutorialEnd(userTutorialsSS);

			for (let i of SJ.itemsManager._items) {
				if (i.id === SJ.playerData.data.boostedItem) {
					i.runOfLuckLevel = 6;
					i.runOfLuckPoints = 5;
					i.isRunOfLuckActive = true;

					i.setItemLevel();
					i.setRunOfLuck();
				}
			}

			SJ.chat = new SJ.Texture(
				'../sj-graphics/UI/chat/chat_collapsed.png',
				1125,
				844
			);
			SJ.dailyBonus = new SJ.DailyBonus();
		}

		SJ.ScreensManager.screens.mainMenu = new SJ.Screen((self) => {
			const menuSS = SJ.ImageLoader.load('./UI/menu/menuSS.png');

			const registratedAccountInfo = new SJ.SpriteSheetTexture(
				menuSS,
				0,
				0,
				null,
				null,
				194,
				0,
				474,
				93
			);

			const sky = new SJ.UI.Element(
				0,
				0,
				SJ.SCREEN_WIDTH,
				SJ.SCREEN_HEIGHT / 2
			);
			sky.color = color('#6ed1e4');
			sky.drawColorBackground = 1;

			const city = new SJ.SpriteSheetTexture(
				menuSS,
				0,
				0,
				null,
				null,
				0,
				921,
				1600,
				900
			);

			const logo = new SJ.AnimatedSpriteSheet(
				'./UI/menu/logo.png',
				50,
				100,
				1000,
				152,
				158,
				30,
				true,
				false,
				true,
				() => setInterval(() => logo.animation.restart(), 7000)
			);

			const jumpBtnHover = new SJ.AnimatedSpriteSheet(
				'./UI/menu/jump-hover.png',
				0,
				0,
				200,
				737,
				499,
				5,
				true,
				false,
				false
			);

			const jumpBtn = new SJ.TextureButton(
				27,
				147,
				null,
				null,
				jumpBtnHover,
				new SJ.SpriteSheetTexture2(
					menuSS,
					0,
					0,
					null,
					null,
					284,
					419,
					723,
					502
				),
				null,
				null,
				() => {
					SJ.ScreensManager.changeScreen(
						SJ.ScreensManager.screens.selectLocation
					);
					SJ.mainMenuSoundContainer.play('worldCup');
				}
			);

			jumpBtn.hoverTexture.animation._loopMode = false;
			jumpBtn.hoverTexture.animation._resetAtEnd = false;
			jumpBtn.setHoverTextureTranslate(6, -15);

			const bankBtnDisabled = new SJ.SpriteSheetTexture(
				menuSS,
				0,
				0,
				null,
				null,
				1316,
				193,
				249,
				226
			);
			const bankBtnHover = new SJ.AnimatedSpriteSheet(
				'./UI/menu/bank-hover.png',
				0,
				0,
				200,
				277,
				254,
				5,
				true,
				false,
				false
			);

			const bankBtn = new SJ.TextureButton(
				167,
				558,
				null,
				null,
				bankBtnHover,
				bankBtnDisabled,
				registratedAccountInfo,
				null,
				() => {
					SJ.ScreensManager.changeScreen(SJ.ScreensManager.screens.bank);
					SJ.mainMenuSoundContainer.play('bank');
				}
			);

			bankBtn.onDisabledMousePress = () => SJ.registration.show();

			bankBtn.hoverTexture.animation._loopMode = false;
			bankBtn.hoverTexture.animation._resetAtEnd = false;

			if (SJ.playerData.data['name'] === 'Guest') {
				bankBtn.disabled = true;
			}

			const vipshopBtnAnimation = new SJ.AnimatedSpriteSheet(
				'./UI/menu/vipclub-animation.png',
				0,
				0,
				1000,
				158,
				164,
				6
			);

			const vipClubBtnDisabled = new SJ.SpriteSheetTexture(
				menuSS,
				0,
				0,
				null,
				null,
				329,
				193,
				261,
				194
			);
			const vipClubHover = new SJ.AnimatedSpriteSheet(
				'./UI/menu/vipclub-hover.png',
				0,
				0,
				200,
				289,
				221,
				5,
				false,
				false,
				false
			);

			const vipclubBtn = new SJ.TextureButton(
				285,
				352,
				null,
				vipshopBtnAnimation,
				vipClubHover,
				vipClubBtnDisabled,
				registratedAccountInfo,
				'disabledTexture',
				() => {
					SJ.ScreensManager.changeScreen(SJ.ScreensManager.screens.vipClub);
					SJ.mainMenuSoundContainer.play('VIPClub');
				}
			);

			vipclubBtn.onDisabledMousePress = () => SJ.registration.show();

			vipclubBtn.mainTexture.animation._duration = 1000;

			vipclubBtn.hoverTexture.animation._loopMode = false;
			vipclubBtn.hoverTexture.animation._resetAtEnd = false;

			vipclubBtn.setMainTextureTranslate(-55, -30);

			if (SJ.playerData.data['name'] === 'Guest') {
				vipclubBtn.disabled = true;
			}

			const shopBtnHover = new SJ.AnimatedSpriteSheet(
				'./UI/menu/shop-hover.png',
				0,
				0,
				200,
				276,
				193,
				5,
				false,
				false,
				false
			);
			const shopBtnDisabled = new SJ.SpriteSheetTexture(
				menuSS,
				0,
				0,
				null,
				null,
				668,
				0,
				249,
				164
			);

			const shopBtn = new SJ.TextureButton(
				890,
				340,
				null,
				null,
				shopBtnHover,
				shopBtnDisabled,
				null,
				null,
				() => {
					SJ.ScreensManager.changeScreen(SJ.ScreensManager.screens.shop);
					SJ.mainMenuSoundContainer.play('shop');
				}
			);

			shopBtn.hoverTexture.animation._loopMode = false;
			shopBtn.hoverTexture.animation._resetAtEnd = false;

			// shopBtn.disabled = true;

			const shopBtnSmoke = new SJ.AnimatedSpriteSheet(
				'./UI/menu/shop-smoke.png',
				995,
				260,
				3000,
				86,
				102,
				30
			);

			const careerBtnDisabled = new SJ.SpriteSheetTexture(
				menuSS,
				0,
				0,
				null,
				null,
				978,
				193,
				338,
				221
			);
			const careerBtnHover = new SJ.AnimatedSpriteSheet(
				'./UI/menu/career-hover.png',
				0,
				0,
				200,
				338,
				221,
				5,
				true,
				false,
				false
			);

			const careerBtn = new SJ.TextureButton(
				605,
				423,
				null,
				null,
				careerBtnHover,
				careerBtnDisabled,
				registratedAccountInfo,
				null,
				() => {
					SJ.ScreensManager.changeScreen(SJ.ScreensManager.screens.career);
					SJ.mainMenuSoundContainer.play('career');
				}
			);

			careerBtn.onDisabledMousePress = () => SJ.registration.show();

			careerBtn.hoverTexture.animation._loopMode = false;
			careerBtn.hoverTexture.animation._resetAtEnd = false;

			if (SJ.playerData.data['name'] === 'Guest') {
				careerBtn.disabled = true;
			}

			const careerBtnSmoke = new SJ.AnimatedSpriteSheet(
				`UI/menu/career-smoke.png`,
				670,
				370,
				3000,
				86,
				102,
				30,
				true,
				true,
				true
			);

			const fountain = new SJ.AnimatedSpriteSheet(
				'./UI/menu/fountain.png',
				770,
				665,
				400,
				97,
				76,
				4
			);

			const ranksAnimation = new SJ.AnimatedSpriteSheet(
				`UI/menu/ranks-animation.png`,
				0,
				0,
				2000,
				295,
				296,
				28,
				true,
				true,
				true
			);

			const ranksBtnDisabled = new SJ.SpriteSheetTexture(
				menuSS,
				0,
				0,
				null,
				null,
				0,
				419,
				284,
				253
			);
			const ranksBtnHover = new SJ.AnimatedSpriteSheet(
				'./UI/menu/ranks-hover.png',
				0,
				0,
				200,
				284,
				253,
				5,
				false,
				false,
				false
			);

			const ranksBtn = new SJ.TextureButton(
				1151,
				428,
				null,
				ranksAnimation,
				ranksBtnHover,
				ranksBtnDisabled,
				null,
				'disabledTexture',
				() => {
					SJ.ScreensManager.changeScreen(SJ.ScreensManager.screens.fameGallery);
					SJ.mainMenuSoundContainer.play('fameGallery');
				}
			);

			ranksBtn.setMainTextureTranslate(-10, 0);

			ranksBtn.hoverTexture.animation._loopMode = false;
			ranksBtn.hoverTexture.animation._resetAtEnd = false;
			// ranksBtn.disabled = true;

			const tournamentButtonDisabled = new SJ.SpriteSheetTexture(
				menuSS,
				0,
				0,
				null,
				null,
				590,
				193,
				388,
				205
			);
			const tournamentBtnHover = new SJ.AnimatedSpriteSheet(
				'./UI/menu/tournament-hover.png',
				0,
				0,
				200,
				388,
				205,
				5,
				false,
				false,
				false
			);

			const tournamentButton = new SJ.TextureButton(
				845,
				170,
				null,
				null,
				tournamentBtnHover,
				tournamentButtonDisabled,
				registratedAccountInfo,
				null,
				() => {
					SJ.ScreensManager.changeScreen(
						SJ.ScreensManager.screens.selectTournament
					);
					SJ.mainMenuSoundContainer.play('tournaments');
				}
			);

			tournamentButton.onDisabledMousePress = () => SJ.registration.show();

			tournamentButton.hoverTexture.animation._loopMode = false;
			tournamentButton.hoverTexture.animation._resetAtEnd = false;

			if (SJ.playerData.data['name'] === 'Guest')
				tournamentButton.disabled = true;

			const settingsDisplay = new SJ.Settings();

			const musicOn = new SJ.TextureButton(
				0,
				0,
				null,
				new SJ.SpriteSheetTexture(
					menuSS,
					-5,
					-5,
					null,
					null,
					150,
					0,
					44,
					39,
					1.3,
					1.3
				),
				null,
				null,
				null,
				null,
				() => {
					SJ.settings.music = false;
					SJ.Tools.updateSettingInDatabase('music', 0);
					SJ.mainSoundtrack.pause();
					musicOn.hide();
					musicOff.show();
				}
			);

			musicOn.w *= 1.3;
			musicOn.h *= 1.3;
			musicOn.widthOffset = 0;
			musicOn.widthOffset = 0;

			const musicOff = new SJ.TextureButton(
				0,
				0,
				null,
				new SJ.SpriteSheetTexture(
					menuSS,
					-5,
					-5,
					null,
					null,
					106,
					0,
					44,
					39,
					1.3,
					1.3
				),
				null,
				null,
				null,
				null,
				() => {
					SJ.settings.music = true;
					SJ.Tools.updateSettingInDatabase('music', 1);
					SJ.mainSoundtrack.play();
					musicOn.show();
					musicOff.hide();
				}
			);

			musicOff.w *= 1.3;
			musicOff.h *= 1.3;
			musicOff.widthOffset = 0;
			musicOff.widthOffset = 0;

			musicOn.onMouseEnter = () => {
				SJ.registration.mouseMode = SJ.UI.MOUSE_MODE.PASS;
			};
			musicOn.onMouseLeave = () => {
				SJ.registration.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			};

			musicOff.onMouseEnter = () => {
				SJ.registration.mouseMode = SJ.UI.MOUSE_MODE.PASS;
			};
			musicOff.onMouseLeave = () => {
				SJ.registration.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			};

			if (SJ.settings.music) {
				musicOn.show();
				musicOff.hide();
			} else {
				musicOn.hide();
				musicOff.show();
			}

			const optionsBtn = new SJ.TextureButton(
				0,
				0,
				null,
				new SJ.SpriteSheetTexture(
					menuSS,
					-5,
					-5,
					null,
					null,
					65,
					0,
					41,
					39,
					1.3,
					1.3
				),
				null,
				null,
				null,
				null,
				() => {
					if (!SJ.registration.isVisible) {
						settingsDisplay.show();
						SJ.mainMenuSoundContainer.play('settings');
					} else return false;
				}
			);

			optionsBtn.w *= 1.3;
			optionsBtn.h *= 1.3;
			optionsBtn.widthOffset = 0;
			optionsBtn.widthOffset = 0;

			const helpBtn = new SJ.TextureButton(
				0,
				0,
				null,
				new SJ.SpriteSheetTexture(
					menuSS,
					-5,
					-5,
					null,
					null,
					0,
					0,
					31,
					39,
					1.3,
					1.3
				),
				null,
				null,
				null,
				null,
				() => {
					if (!SJ.registration.isVisible && SJ.newUserTutorial) {
						SJ.newUserTutorial.show();
						SJ.tutorial1.hide();
						SJ.tutorial2.hide();
						SJ.tutorial3.hide();
						SJ.tutorial4.hide();
						SJ.tutorial5.hide();
						SJ.tutorial6.hide();
						SJ.tutorialEnd.hide();
						SJ.mainMenuSoundContainer.play('tutorial');
					} else if (!SJ.registration.isVisible && !SJ.newUserTutorial)
						SJ.demoTutorial.show();
					else if (SJ.registration.isVisible && SJ.registrationTutorial)
						SJ.registrationTutorial.show();
					else return false;
				}
			);

			helpBtn.w *= 1.3;
			helpBtn.h *= 1.3;
			helpBtn.widthOffset = 0;
			helpBtn.widthOffset = 0;

			helpBtn.onMouseEnter = () => {
				SJ.registration.mouseMode = SJ.UI.MOUSE_MODE.PASS;
			};
			helpBtn.onMouseLeave = () => {
				SJ.registration.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			};

			const logoutBtn = new SJ.TextureButton(
				0,
				0,
				null,
				new SJ.SpriteSheetTexture(
					menuSS,
					-5,
					-5,
					null,
					null,
					31,
					0,
					34,
					39,
					1.3,
					1.3
				),
				null,
				null,
				null,
				null,
				() => {
					if (!SJ.registration.isVisible) {
						if (SJ.playerData.data['name'] !== 'Guest') {
							SJ.mainMenuSoundContainer.play('logOut');
							window.setTimeout(() => {
								if (sessionStorage.getItem('playername')) {
									sessionStorage.removeItem('playername');
									sessionStorage.removeItem('playerpassword');
									SJ.playerData.setDefault();

									FB.getLoginStatus(function (response) {
										if (response.status === 'connected') FB.logout();
									});

									location = window.location.origin + '/game';

									// console.log('LOGOUT');
								}
							}, 1000);
							// SJ.Login.logout();
						} else {
							SJ.registration.show();
						}
					} else return false;
				}
			);

			logoutBtn.w *= 1.3;
			logoutBtn.h *= 1.3;
			logoutBtn.widthOffset = 0;
			logoutBtn.widthOffset = 0;

			const optionsBtnLayout = new SJ.Layout(
				SJ.SCREEN_WIDTH - 330,
				144,
				[musicOn, musicOff, optionsBtn, helpBtn, logoutBtn],
				32
			);

			const birdsAnimation = new SJ.AnimatedSpriteSheet(
				'../sj-graphics/UI/menu/birds-animation.png',
				(SJ.SCREEN_WIDTH * 2) / 3,
				120,
				1000,
				100,
				50,
				8
			);

			birdsAnimation.draw = () => {
				birdsAnimation.x -= 0.1;
				if (birdsAnimation.x < 40) birdsAnimation.x = SJ.SCREEN_WIDTH;

				birdsAnimation.animation.draw();
			};

			const clouds = new SJ.SpriteSheetTexture(
				menuSS,
				100,
				80,
				null,
				null,
				917,
				0,
				814,
				193
			);

			clouds.draw = () => {
				clouds.x += 0.05;

				if (clouds.x > SJ.SCREEN_WIDTH) clouds.x = -clouds.w;

				image(
					clouds.texture,
					0,
					0,
					clouds.w * clouds.scaleX,
					clouds.h * clouds.scaleY,
					917,
					0,
					814,
					193
				);
			};

			const clouds2 = new SJ.SpriteSheetTexture(
				menuSS,
				SJ.SCREEN_WIDTH - 500,
				60,
				null,
				null,
				0,
				193,
				329,
				193
			);

			clouds2.draw = () => {
				clouds2.x -= 0.05;

				if (clouds2.x < -clouds2.w) clouds2.x = SJ.SCREEN_WIDTH;

				image(
					clouds2.texture,
					0,
					0,
					clouds2.w * clouds2.scaleX,
					clouds2.h * clouds2.scaleY,
					0,
					193,
					329,
					193
				);
			};

			const lampTexture = new SJ.AnimatedSpriteSheet(
				'./UI/menu/lamps-animation.png',
				0,
				0,
				2000,
				200,
				200,
				20
			);

			const lamp = new SJ.TextureButton(150, 340, null, lampTexture);
			lamp.widthOffset = 0;
			lamp.heightOffset = 0;
			const lamp2 = new SJ.TextureButton(470, 250, null, lampTexture);
			lamp2.widthOffset = 0;
			lamp2.heightOffset = 0;
			const lamp3 = new SJ.TextureButton(690, 240, null, lampTexture);
			lamp3.widthOffset = 0;
			lamp3.heightOffset = 0;
			const lamp4 = new SJ.TextureButton(850, 320, null, lampTexture);
			lamp4.widthOffset = 0;
			lamp4.heightOffset = 0;
			const lamp5 = new SJ.TextureButton(970, 360, null, lampTexture);
			lamp5.widthOffset = 0;
			lamp5.heightOffset = 0;
			const lamp6 = new SJ.TextureButton(1310, 440, null, lampTexture);
			lamp6.widthOffset = 0;
			lamp6.heightOffset = 0;
			const lamp7 = new SJ.TextureButton(970, 580, null, lampTexture);
			lamp7.widthOffset = 0;
			lamp7.heightOffset = 0;
			const lamp8 = new SJ.TextureButton(550, 610, null, lampTexture);
			lamp8.widthOffset = 0;
			lamp8.heightOffset = 0;
			const lamp9 = new SJ.TextureButton(310, 530, null, lampTexture);
			lamp9.widthOffset = 0;
			lamp9.heightOffset = 0;

			const paymentSuccessNotification = new SJ.PaymentSuccessNotification(
				bankSS
			);

			self.appendDrawable(sky);

			self.appendDrawable(clouds);
			self.appendDrawable(clouds2);

			self.appendDrawable(birdsAnimation);

			self.appendDrawable(city);

			self.appendDrawable(logo);

			self.appendDrawable(jumpBtn);
			self.appendDrawable(tournamentButton);

			self.appendDrawable(careerBtn);
			self.appendDrawable(careerBtnSmoke);

			self.appendDrawable(shopBtn);
			self.appendDrawable(shopBtnSmoke);

			self.appendDrawable(vipclubBtn);
			self.appendDrawable(bankBtn);
			self.appendDrawable(ranksBtn);
			self.appendDrawable(fountain);

			self.appendDrawable(lamp);
			self.appendDrawable(lamp2);
			self.appendDrawable(lamp3);
			self.appendDrawable(lamp4);
			self.appendDrawable(lamp5);
			self.appendDrawable(lamp6);
			self.appendDrawable(lamp7);
			self.appendDrawable(lamp8);
			self.appendDrawable(lamp9);

			self.appendDrawable(settingsDisplay);

			self.appendDrawable(optionsBtnLayout);

			self.appendDrawable(SJ.userDataBar);

			self.appendDrawable(paymentSuccessNotification);

			self.appendDrawable(SJ.registrationTutorial);

			self.appendDrawable(SJ.registration);

			self.appendDrawable(SJ.demoTutorial);

			if (SJ.newUserTutorial) {
				self.appendDrawable(SJ.newUserTutorial);
				self.appendDrawable(SJ.tutorial1);
				self.appendDrawable(SJ.tutorial2);
				self.appendDrawable(SJ.tutorial3);
				self.appendDrawable(SJ.tutorial4);
				self.appendDrawable(SJ.tutorial5);
				self.appendDrawable(SJ.tutorial6);
				self.appendDrawable(SJ.tutorialEnd);

				self.appendDrawable(SJ.chat);
				self.appendDrawable(SJ.dailyBonus);
			}

			self.appendDrawable(
				new SJ.LoadingWindow(() => {
					const queryString = window.location.search;
					const urlParams = new URLSearchParams(queryString);

					if (
						urlParams.get('tkn') &&
						!window.sessionStorage.getItem('playername')
					)
						SJ.registration.show(true);
					else if (
						urlParams.get('demo') &&
						!window.sessionStorage.getItem('playername')
					)
						SJ.demoTutorial.show();
					else if (!window.sessionStorage.getItem('playername')) {
						SJ.registration.show();
					}
				})
			);

			// const renderScreen = () => {
			//   self._drawableAbsolute = [];
			//   self._drawable = [];
			// }

			self.onScreenChange = () => {
				// renderScreen();

				SJ.userDataBar.updateDisplayData();

				if (SJ.playerData.data['moneySpent'] >= 50000) SJ.tutorial1.hide();
				if (SJ.playerData.data['successfulJumps'] > 0 && SJ.playerData.data['name'] !== 'Guest') SJ.tutorial2.hide();
				if (SJ.playerData.data['finishedTournaments'] > 0) SJ.tutorial3.hide();
				if (SJ.playerData.data['successfulJumps'] >= 25) SJ.tutorial4.hide();
				if (SJ.playerData.data['VIPmoneySpent'] > 0) SJ.tutorial5.hide();
				if (
					SJ.playerData.data['mapGlobalRankingScore'] >= 750 &&
					SJ.playerData.data['tournamentRankingScore'] >= 750
				)
					SJ.tutorial6.hide();

				if (
					SJ.playerData.data['moneySpent'] >= 50000 &&
					SJ.playerData.data['successfulJumps'] > 0 &&
					SJ.playerData.data['finishedTournaments'] > 0 &&
					SJ.playerData.data['successfulJumps'] >= 25 &&
					SJ.playerData.data['VIPmoneySpent'] > 0 &&
					SJ.playerData.data['mapGlobalRankingScore'] >= 750 &&
					SJ.playerData.data['tournamentRankingScore'] >= 750 &&
					!SJ.playerData.data.isTutorialFinished
				)
					SJ.tutorialEnd.show();
			};
		});

		SJ.ScreensManager.screens.selectLocation = new SJ.Screen((self) => {
			const locations = [
				['Szczyrk', 'Szczyrk'],
				['Oberstdorf', 'Oberstdorf'],
				['Zakopane', 'Zakopane'],
				['Vikersund', 'Vikersund'],
				['Planica', 'Planica'],
				['Pekin 2030', 'Pekin2030'],
			];

			self.onScreenChange = () => {
				self._drawable = [];

				self.appendDrawable(
					new SJ.Label(
						'ŁADOWANIE',
						SJ.SCREEN_MIDDLE_X,
						SJ.SCREEN_MIDDLE_Y,
						CENTER,
						CENTER
					)
				);

				const locationSelect = SJ.ImageLoader.load(
					'../sj-graphics/UI/location-select-screen/locationSelectSS.png'
				);

				const mainImage = new SJ.Texture(
					'../sj-graphics/UI/location-select-screen/main-image.png',
					0,
					0,
					0,
					0,
					null,
					SJ.SCREEN_WIDTH
				);

				const mapImage1 = new SJ.SpriteSheetTexture(
					locationSelect,
					18,
					126.5,
					null,
					null,
					1098,
					648,
					221,
					610
				);
				const mapImage2 = new SJ.SpriteSheetTexture(
					locationSelect,
					148.5,
					126.5,
					null,
					null,
					214,
					648,
					221,
					610
				);
				const mapImage3 = new SJ.SpriteSheetTexture(
					locationSelect,
					279,
					126.5,
					null,
					null,
					1540,
					648,
					221,
					610
				);
				const mapImage4 = new SJ.SpriteSheetTexture(
					locationSelect,
					409.5,
					126.5,
					null,
					null,
					1319,
					648,
					221,
					610
				);
				const mapImage5 = new SJ.SpriteSheetTexture(
					locationSelect,
					540.5,
					126.5,
					null,
					null,
					877,
					648,
					221,
					610
				);
				const mapImage6 = new SJ.SpriteSheetTexture(
					locationSelect,
					671,
					126.5,
					null,
					null,
					655,
					648,
					222,
					610
				);

				const backBtn = new BackToMenuBtn(127, 184);

				self.appendDrawable(mainImage);
				self.appendDrawable(SJ.userDataBar);
				self.appendDrawable(backBtn);

				self.appendDrawable(mapImage1);
				self.appendDrawable(mapImage2);
				self.appendDrawable(mapImage3);
				self.appendDrawable(mapImage4);
				self.appendDrawable(mapImage5);
				self.appendDrawable(mapImage6);

				let i = 0;

				const hoverAnimation = new SJ.AnimatedSpriteSheet(
					'./UI/location-select-screen/hover.png',
					0,
					0,
					200,
					274,
					648,
					5,
					false,
					false,
					false
				);

				const pekinLocationButton = new SJ.TextureButton(
					1344,
					272,
					null,
					null,
					hoverAnimation,
					new SJ.SpriteSheetTexture(
						locationSelect,
						0,
						0,
						null,
						null,
						0,
						648,
						214,
						588
					),
					new SJ.SpriteSheetTexture(
						locationSelect,
						0,
						0,
						null,
						null,
						435,
						648,
						220,
						123
					),
					'hoverTexture',
					() => SJ._startGame(locations[5][1], locations[5][0]),
					null,
					null,
					null,
					false
				);

				pekinLocationButton.setSize(245, 655);
				pekinLocationButton.widthOffset = 0;
				pekinLocationButton.heightOffset = 0;

				const pekinDisabledButton = new SJ.TextureButton(
					1344,
					272,
					null,
					null,
					null,
					null,
					null,
					null,
					() => {
						SJ.ScreensManager.changeScreen(SJ.ScreensManager.screens.vipClub);
						SJ.mainMenuSoundContainer.play('VIPClub');
					}
				);

				pekinDisabledButton.w = 220;
				pekinDisabledButton.h = 590;

				if (SJ.playerData.data['name'] !== 'Guest')
					self.appendDrawable(pekinDisabledButton);

				if (SJ.playerData.data['isVip'] === false) {
					pekinLocationButton.disabled = true;
					pekinLocationButton.onDisabledMousePress = () => {
						if (SJ.playerData.data['name'] !== 'Guest')
							SJ.ScreensManager.changeScreen(SJ.ScreensManager.screens.vipClub);
						else {
							SJ.registration.show();
						}
					};
				} else {
					self.appendDrawable(pekinLocationButton);
				}

				const locationButtonsX = [22, 283, 543, 805, 1068, 1328];

				locations.forEach((location) => {
					let locationButton = new SJ.TextureButton(
						locationButtonsX[i] + 15,
						272,
						null,
						null,
						hoverAnimation,
						new SJ.SpriteSheetTexture(
							locationSelect,
							0,
							0,
							null,
							null,
							220,
							0,
							213,
							588
						),
						new SJ.SpriteSheetTexture(
							locationSelect,
							0,
							0,
							null,
							null,
							0,
							0,
							220,
							123
						),
						'hoverTexture',
						() => SJ._startGame(location[1], location[0]),
						null,
						null,
						null,
						false
					);

					locationButton.setSize(245, 655);
					locationButton.widthOffset = 0;
					locationButton.heightOffset = 0;

					if (
						(location[1] === 'Planica' || location[1] === 'Vikersund') &&
						SJ.playerData.data['name'] === 'Guest'
					) {
						locationButton.disabled = true;
						locationButton.onDisabledMousePress = () => {
							SJ.registration.show();
						};
					}

					if (location[1] !== 'Pekin 2030') self.appendDrawable(locationButton);

					i++;
				});

				if (pekinLocationButton.disabled === true)
					self.appendDrawable(pekinLocationButton);

				self.appendDrawable(SJ.registration);
				self.appendDrawable(new SJ.LoadingWindow());
			};
		});

		SJ.ScreensManager.screens.selectTournament = new SJ.Screen((self) => {
			self.onScreenChange = () => {
				self.appendDrawable(
					new SJ.Label(
						'ŁADOWANIE',
						SJ.SCREEN_MIDDLE_X,
						SJ.SCREEN_MIDDLE_Y,
						CENTER,
						CENTER
					)
				);

				fetch(`${SJ.APILink}tournaments/getAll.php`)
					.then((res) => {
						return res.json();
					})
					.then((res) => {
						self._drawable = [];

						const tournamentSelectSreenSS = SJ.ImageLoader.load(
							'UI/tournament-select-screen/tournamentSelectSreenSS.png'
						);

						const mainGraphic = new SJ.SpriteSheetTexture(
							tournamentSelectSreenSS,
							0,
							0,
							null,
							null,
							0,
							254,
							1600,
							900
						);
						self.appendDrawable(mainGraphic);

						const backBtn = new BackToMenuBtn(150, 180);

						const hoverAnimationSS = new SJ.AnimatedSpriteSheet(
							'./UI/tournament-select-screen/hover.png',
							0,
							0,
							200,
							349,
							296,
							5,
							true,
							false,
							false
						);
						const lockedHoverTexture = new SJ.SpriteSheetTexture(
							tournamentSelectSreenSS,
							0,
							0,
							null,
							null,
							0,
							0,
							176,
							86
						);

						const fisCup = new SJ.TournamentButton(
							93,
							264,
							res[0]['name'],
							res[0]['minRank'],
							res[0]['mapsList'],
							res[0]['seriesCount'],
							hoverAnimationSS,
							null,
							lockedHoverTexture
						);
						fisCup.setSize(309, 254);

						const continentalCup = new SJ.TournamentButton(
							446,
							264,
							res[1]['name'],
							res[1]['minRank'],
							res[1]['mapsList'],
							res[1]['seriesCount'],
							hoverAnimationSS,
							new SJ.SpriteSheetTexture(
								tournamentSelectSreenSS,
								0,
								0,
								null,
								null,
								352,
								0,
								309,
								254
							),
							lockedHoverTexture
						);

						const worldCup = new SJ.TournamentButton(
							797,
							264,
							res[2]['name'],
							res[2]['minRank'],
							res[2]['mapsList'],
							res[2]['seriesCount'],
							hoverAnimationSS,
							new SJ.SpriteSheetTexture(
								tournamentSelectSreenSS,
								0,
								0,
								null,
								null,
								1588,
								0,
								309,
								254
							),
							lockedHoverTexture
						);

						const flyingWorldCup = new SJ.TournamentButton(
							94,
							570,
							res[3]['name'],
							res[3]['minRank'],
							res[3]['mapsList'],
							res[3]['seriesCount'],
							hoverAnimationSS,
							new SJ.SpriteSheetTexture(
								tournamentSelectSreenSS,
								0,
								0,
								null,
								null,
								970,
								0,
								309,
								254
							),
							lockedHoverTexture
						);

						const fourHillsTournament = new SJ.TournamentButton(
							446,
							570,
							res[4]['name'],
							res[4]['minRank'],
							res[4]['mapsList'],
							res[4]['seriesCount'],
							hoverAnimationSS,
							new SJ.SpriteSheetTexture(
								tournamentSelectSreenSS,
								0,
								0,
								null,
								null,
								1279,
								0,
								309,
								254
							),
							lockedHoverTexture
						);

						const flyingWorldChampionship = new SJ.TournamentButton(
							798,
							569,
							res[5]['name'],
							res[5]['minRank'],
							res[5]['mapsList'],
							res[5]['seriesCount'],
							hoverAnimationSS,
							new SJ.SpriteSheetTexture(
								tournamentSelectSreenSS,
								0,
								0,
								null,
								null,
								661,
								0,
								309,
								254
							),
							new SJ.SpriteSheetTexture(
								tournamentSelectSreenSS,
								0,
								0,
								null,
								null,
								176,
								0,
								176,
								86
							)
						);

						self.appendDrawable(fisCup);
						self.appendDrawable(continentalCup);
						self.appendDrawable(worldCup);
						self.appendDrawable(flyingWorldCup);
						self.appendDrawable(fourHillsTournament);
						self.appendDrawable(flyingWorldChampionship);

						self.appendDrawable(backBtn);

						self.appendDrawable(SJ.userDataBar);
						self.appendDrawable(SJ.registration);

						self.appendDrawable(new SJ.LoadingWindow());
					});
			};
		});

		SJ.ScreensManager.screens.shop = new SJ.Screen((self) => {
			const items = SJ.itemsManager._items.sort((a, b) => {
				if (a.orderNumberInShop > b.orderNumberInShop) return 1;
				else return -1;
			});

			const shopSS = SJ.ImageLoader.load('UI/shop/shopSS.png');

			const itemTextures = {
				'bindings.png': SJ.ImageLoader.load(
					'../sj-graphics/UI/shop/bindings.png'
				),
				'boots.png': SJ.ImageLoader.load('../sj-graphics/UI/shop/boots.png'),
				'gloves.png': SJ.ImageLoader.load('../sj-graphics/UI/shop/gloves.png'),
				'goggles.png': SJ.ImageLoader.load(
					'../sj-graphics/UI/shop/goggles.png'
				),
				'helmet.png': SJ.ImageLoader.load('../sj-graphics/UI/shop/helmet.png'),
				'skis.png': SJ.ImageLoader.load('../sj-graphics/UI/shop/skis.png'),
				'suit.png': SJ.ImageLoader.load('../sj-graphics/UI/shop/suit.png'),
			};

			let currentItem = items[0];
			const runOfLuckPointsToAdd = 5;

			const goodRunOfLuckLevel = 3;
			const megaRunOfLuckLevel = 6;

			const goodRunOfLuckPrice = 5;
			const megaRunOfLuckPrice = 10;

			const getRunOfLuckUpgradeCost = () => {
				if (currentItem.runOfLuckLevel === goodRunOfLuckLevel)
					return (
						(currentItem.runOfLuckPoints * (megaRunOfLuckPrice / 2)) /
						runOfLuckPointsToAdd
					);

				return megaRunOfLuckPrice;
			};

			self.appendDrawable(
				new SJ.SpriteSheetTexture(shopSS, 0, 0, null, null, 0, 186, 1600, 900)
			);
			self.appendDrawable(SJ.userDataBar);

			const backBtn = new BackToMenuBtn(1336.5, 175);

			let itemTexture = new SJ.SpriteSheetTexture2(
				itemTextures['skis.png'],
				0,
				0,
				null,
				null,
				0,
				0,
				1600,
				900
			);
			itemTexture.workingName = 'itemTexture';

			const fontSize = 24;
			const x = 420;
			const y = 257;
			const ySeparator = 40;

			const level = new SJ.Label(
				'foo',
				x,
				y,
				LEFT,
				CENTER,
				fontSize + 6,
				color(255),
				null,
				color(0),
				4
			);
			level.workingName = 'level';

			const curPower = new SJ.Label(
				'fooo',
				x,
				y + ySeparator,
				LEFT,
				CENTER,
				fontSize,
				color(102, 230, 25),
				null,
				color(0),
				4
			);
			curPower.workingName = 'curPower';

			const nextLvlPower = new SJ.Label(
				'foooo',
				x,
				y + ySeparator * 2,
				LEFT,
				CENTER,
				fontSize,
				color(255),
				null,
				color(0),
				4
			);
			nextLvlPower.workingName = 'nextLvlPower';

			const price = new SJ.Label(
				'',
				0,
				0,
				null,
				CENTER,
				fontSize,
				color(255),
				null,
				color(0),
				4
			);

			const euroImage = new SJ.SpriteSheetTexture2(
				shopSS,
				0,
				0,
				null,
				null,
				0,
				0,
				36,
				36
			);

			const priceLayout = new SJ.Layout(
				x,
				y + ySeparator * 3,
				[price, euroImage],
				10,
				'row'
			);
			priceLayout.workingName = 'price';

			const goodRunOfLuckLabel = new SJ.Label(
				``,
				1480,
				345,
				RIGHT,
				CENTER,
				28,
				color(102, 230, 25),
				null,
				color(0),
				4
			);
			goodRunOfLuckLabel.workingName = 'goodRunOfLuckLabel';

			const megaRunOfLuckLabel = new SJ.Label(
				``,
				1050,
				590,
				LEFT,
				CENTER,
				28,
				color(102, 230, 25),
				null,
				color(0),
				4
			);
			megaRunOfLuckLabel.workingName = 'megaRunOfLuckLabel';

			const runOfLuckPointsLabel = new SJ.Label(
				``,
				1265,
				445,
				CENTER,
				CENTER,
				20,
				color(255),
				null,
				color(0),
				4
			);
			runOfLuckPointsLabel.workingName = 'runOfLuckPointsLabel';

			const vipDiscountImage = new SJ.SpriteSheetTexture(
				shopSS,
				x / 2,
				201,
				null,
				null,
				494,
				1086,
				85,
				25
			);

			const goodRunOfLuckButton = new SJ.TextureButton(
				1090,
				250,
				null,
				null,
				null,
				new SJ.SpriteSheetTexture(shopSS, 0, 0, null, null, 611, 0, 422, 176),
				null,
				null,
				() => {
					if (SJ.playerData.data['name'] !== 'Guest') {
						goodRunOfLuckButton.disabled = true;

						fetch(
							`https://skijumpsimulator.com/game/af8542a0e7f38c7b6c3268bf335a6865beacbb609fb70e14803fdda0d3a9aff9.php`
						)
							.then((res) => {
								return res.json();
							})
							.then((res) => {
								fetch(
									`${SJ.APILink}run-of-luck/addRunOfLuck.php?itemId=${currentItem.id}&userName=${SJ.playerData.data['name']}&cost=${goodRunOfLuckPrice}&runOfLuckLevel=${goodRunOfLuckLevel}&authKey=${res}`
								)
									.then((res) => {
										return res.json();
									})
									.then((res) => {
										if (res === 'CORRECT') {
											goodRunOfLuckButton.disabled = false;

											fbq('track', 'AddPaymentInfo', {
												currency: 'PLN',
												value: 3,
											});

											const itemIndex =
												SJ.itemsManager._items.indexOf(currentItem);

											SJ.itemsManager._items[itemIndex].runOfLuckLevel =
												goodRunOfLuckLevel;
											SJ.itemsManager._items[itemIndex].runOfLuckPoints +=
												runOfLuckPointsToAdd;
											SJ.playerData.data['VIPmoney'] -= goodRunOfLuckPrice;
											SJ.playerData.data['VIPmoneySpent'] += goodRunOfLuckPrice;

											if (
												SJ.playerData.data['VIPmoney'] - goodRunOfLuckPrice <
												0
											)
												goodRunOfLuckButton.disabled = true;

											SJ.userDataBar.updateDisplayData();
											renderItemStats(currentItem);
										}
									});
							});
					}
				}
			);

			const megaRunOfLuckButton = new SJ.TextureButton(
				1065,
				490,
				null,
				null,
				null,
				new SJ.SpriteSheetTexture(shopSS, 0, 0, null, null, 1033, 0, 447, 186),
				null,
				null,
				() => {
					if (SJ.playerData.data['name'] !== 'Guest') {
						const cost = getRunOfLuckUpgradeCost();

						megaRunOfLuckButton.disabled = true;

						let upgradeLevel = 'false';
						if (currentItem.runOfLuckLevel === 3) upgradeLevel = 'true';

						fetch(
							`https://skijumpsimulator.com/game/af8542a0e7f38c7b6c3268bf335a6865beacbb609fb70e14803fdda0d3a9aff9.php`
						)
							.then((res) => {
								return res.json();
							})
							.then((res) => {
								fetch(
									`${SJ.APILink}run-of-luck/addRunOfLuck.php?itemId=${currentItem.id}&userName=${SJ.playerData.data['name']}&cost=${cost}&runOfLuckLevel=${megaRunOfLuckLevel}&upgradeLevel=${upgradeLevel}&authKey=${res}`
								)
									.then((res) => {
										return res.json();
									})
									.then((res) => {
										if (res === 'CORRECT') {
											megaRunOfLuckButton.disabled = false;

											fbq('track', 'AddPaymentInfo', {
												currency: 'PLN',
												value: 3,
											});

											const itemIndex =
												SJ.itemsManager._items.indexOf(currentItem);

											SJ.itemsManager._items[itemIndex].runOfLuckLevel =
												megaRunOfLuckLevel;

											if (upgradeLevel === 'false')
												SJ.itemsManager._items[itemIndex].runOfLuckPoints +=
													runOfLuckPointsToAdd;

											SJ.playerData.data['VIPmoney'] -= cost;
											SJ.playerData.data['VIPmoneySpent'] += cost;

											if (
												SJ.playerData.data['VIPmoney'] - megaRunOfLuckPrice <
												0
											)
												megaRunOfLuckButton.disabled = true;

											if (currentItem.runOfLuckLevel === megaRunOfLuckLevel)
												goodRunOfLuckButton.disabled = true;

											SJ.userDataBar.updateDisplayData();
											renderItemStats(currentItem);
										}
									});
							});
					}
				}
			);

			const goodRunOfLuckSpeechBubble = new SJ.SpeechBubble(
				`Koszt ulepszenia: \n${goodRunOfLuckPrice} Monet VIP`
			);
			goodRunOfLuckSpeechBubble.workingName = 'goodRunOfLuckSpeechBubble';

			goodRunOfLuckButton.onMouseEnter = () => goodRunOfLuckSpeechBubble.show();
			goodRunOfLuckButton.onMouseLeave = () => goodRunOfLuckSpeechBubble.hide();

			const megaRunOfLuckSpeechBubble = new SJ.SpeechBubble(``);
			megaRunOfLuckSpeechBubble.workingName = 'goodRunOfLuckSpeechBubble';

			megaRunOfLuckSpeechBubble.x = 230;

			megaRunOfLuckButton.onMouseEnter = () => megaRunOfLuckSpeechBubble.show();
			megaRunOfLuckButton.onMouseLeave = () => megaRunOfLuckSpeechBubble.hide();

			goodRunOfLuckButton.addChild(goodRunOfLuckSpeechBubble);
			megaRunOfLuckButton.addChild(megaRunOfLuckSpeechBubble);

			const bankBtn = new SJ.TextureButton(
				1015,
				772,
				null,
				null,
				new SJ.SpriteSheetTexture(shopSS, 0, 0, null, null, 36, 0, 127, 118),
				null,
				null,
				null,
				() => {
					SJ.ScreensManager.changeScreen(SJ.ScreensManager.screens.bank);
					SJ.mainMenuSoundContainer.play('bank');
				}
			);
			self.appendDrawable(bankBtn);

			const vipClubBtn = new SJ.TextureButton(
				1316,
				767,
				null,
				null,
				new SJ.SpriteSheetTexture(shopSS, 0, 0, null, null, 163, 0, 249, 112),
				null,
				null,
				null,
				() => {
					SJ.ScreensManager.changeScreen(SJ.ScreensManager.screens.vipClub);
					SJ.mainMenuSoundContainer.play('VIPClub');
				}
			);
			self.appendDrawable(vipClubBtn);

			const vipClubBtn2 = new SJ.TextureButton(
				107,
				462,
				null,
				new SJ.SpriteSheetTexture(shopSS, 0, 0, null, null, 412, 0, 199, 37),
				null,
				null,
				null,
				null,
				() => {
					SJ.ScreensManager.changeScreen(SJ.ScreensManager.screens.vipClub);
					SJ.mainMenuSoundContainer.play('VIPClub');
				}
			);

			if (SJ.playerData.data['name'] === 'Guest') {
				bankBtn.onMousePress = () => { };
				bankBtn.hoverTexture = null;

				vipClubBtn.onMousePress = () => { };
				vipClubBtn.hoverTexture = null;

				vipClubBtn2.onMousePress = () => { };
			}

			const upgradeButton = new SJ.TextureButton(
				85,
				405,
				null,
				new SJ.SpriteSheetTexture(shopSS, 0, 0, null, null, 247, 1086, 247, 52),
				null,
				new SJ.SpriteSheetTexture(shopSS, 0, 0, null, null, 0, 1086, 247, 52),
				null,
				null,
				() => {
					if (SJ.playerData.data['name'] !== 'Guest') {
						upgradeButton.disabled = true;
						fetch(
							`${SJ.APILink}item/updateItemLevel.php?userName=${SJ.playerData.data['name']}&itemId=${currentItem.id}&itemPrice=${currentItem.price}`
						)
							.then((res) => {
								return res.json();
							})
							.then((res) => {
								if (res === 'CORRECT') {
									upgradeButton.disabled = false;
									upgradeItem(currentItem);
								}
							});
					} else {
						upgradeItem(currentItem);
					}
				}
			);

			const renderItemStats = (item) => {
				const increment = `${item.increment ? '+' : '-'}`;

				const levelIndex = self._drawable.findIndex((e) => {
					return e.workingName === 'level';
				});
				self._drawable[levelIndex].content = `${item.level}`;

				const curPowerIndex = self._drawable.findIndex((e) => {
					return e.workingName === 'curPower';
				});
				self._drawable[curPowerIndex].content = `${increment} ${item.varMult}%`;

				const nextLvlPowerIndex = self._drawable.findIndex((e) => {
					return e.workingName === 'nextLvlPower';
				});
				self._drawable[
					nextLvlPowerIndex
				].content = `${increment} ${item.getVarMult(item.level + 1)}%`;

				const priceLayoutIndex = self._drawable.findIndex((e) => {
					return e.workingName === 'price';
				});
				self._drawable[priceLayoutIndex].children[0].content = `${item.price}`;

				if (SJ.playerData.data['isVip'])
					self._drawable[priceLayoutIndex].children[0].fontColor = color(
						242,
						188,
						43
					);

				const goodRunOfLuckLabelIndex = self._drawable.findIndex((e) => {
					return e.workingName === 'goodRunOfLuckLabel';
				});
				self._drawable[
					goodRunOfLuckLabelIndex
				].content = `${increment} ${item.getVarMult(
					item.level + goodRunOfLuckLevel
				)}%`;

				const megaRunOfLuckLabelIndex = self._drawable.findIndex((e) => {
					return e.workingName === 'megaRunOfLuckLabel';
				});
				self._drawable[
					megaRunOfLuckLabelIndex
				].content = `${increment} ${item.getVarMult(
					item.level + megaRunOfLuckLevel
				)}%`;

				const runOfLuckPointsLabelIndex = self._drawable.findIndex((e) => {
					return e.workingName === 'runOfLuckPointsLabel';
				});
				self._drawable[runOfLuckPointsLabelIndex].content = `ILOŚĆ SKOKÓW Z ${item.runOfLuckLevel === megaRunOfLuckLevel ? 'MEGA' : 'DOBRĄ'
					} PASSĄ: ${item.runOfLuckPoints}`;

				megaRunOfLuckSpeechBubble.label.content = `${item.runOfLuckLevel === megaRunOfLuckLevel ||
					item.runOfLuckPoints === 0
					? `Koszt ulepszenia:\n${megaRunOfLuckPrice} Monet VIP`
					: `Zamiana Dobrej Passy\nna Mega Passę\nKoszt: ${getRunOfLuckUpgradeCost()} Monet VIP`
					}`;
			};

			const upgradeItem = (item) => {
				if (SJ.playerData.data['money'] - item.price < 0) return;

				SJ.playerData.data['money'] -= item.price;
				SJ.playerData.data['moneySpent'] += item.price;

				const itemIndex = SJ.itemsManager._items.indexOf(item);

				SJ.itemsManager._items[itemIndex].level++;
				SJ.itemsManager._items[itemIndex].calculateVariables();

				currentItem = SJ.itemsManager._items[itemIndex];
				if (item.varMult < 0) item.varMult *= -1;

				if (SJ.playerData.data['money'] - currentItem.price < 0)
					upgradeButton.disabled = true;

				let levelSum = 0;

				SJ.itemsManager._items.forEach((item) => {
					levelSum += item.level;
				});

				if (levelSum === 1)
					fbq('track', 'AddToCard', {
						currency: 'PLN',
						value: 1.15,
					});

				renderItemStats(currentItem);
				SJ.userDataBar.updateDisplayData();
			};

			const changeItem = (item) => {
				currentItem = item;

				const itemTextureIndex = self._drawable.findIndex((e) => {
					return e.workingName === 'itemTexture';
				});

				itemTexture = new SJ.SpriteSheetTexture2(
					itemTextures[item.imageName],
					0,
					0,
					null,
					null,
					0,
					0,
					1600,
					900
				);
				itemTexture.workingName = 'itemTexture';

				self._drawable[itemTextureIndex] = itemTexture;

				renderItemStats(item);

				if (SJ.playerData.data['money'] - currentItem.price < 0)
					upgradeButton.disabled = true;
				else upgradeButton.disabled = false;

				if (SJ.playerData.data['VIPmoney'] - goodRunOfLuckPrice < 0)
					goodRunOfLuckButton.disabled = true;
				else goodRunOfLuckButton.disabled = false;

				if (SJ.playerData.data['VIPmoney'] - megaRunOfLuckPrice < 0)
					megaRunOfLuckButton.disabled = true;
				else megaRunOfLuckButton.disabled = false;

				if (SJ.playerData.data['isVip']) vipDiscountImage.show();
				else vipDiscountImage.hide();

				if (currentItem.runOfLuckLevel === megaRunOfLuckLevel)
					goodRunOfLuckButton.disabled = true;
			};

			self.appendDrawable(level);
			self.appendDrawable(curPower);
			self.appendDrawable(nextLvlPower);
			self.appendDrawable(priceLayout);

			self.appendDrawable(runOfLuckPointsLabel);
			self.appendDrawable(vipDiscountImage);

			const xSeparator = 126.5;
			let i = 0;

			const itemBtnHover = new SJ.AnimatedSpriteSheet(
				'./UI/shop/hover.png',
				0,
				0,
				200,
				115,
				95,
				5,
				true,
				false,
				false
			);

			items.forEach((item) => {
				const itemBtn = new SJ.TextureButton(
					42 + xSeparator * i,
					119,
					null,
					null,
					itemBtnHover,
					null,
					null,
					null,
					() => changeItem(item)
				);

				itemBtn.w = 115;
				itemBtn.h = 95;

				itemBtn.setHoverTextureTranslate(-6, -6);

				itemBtn.hoverTexture.animation._resetAtEnd = false;
				itemBtn.hoverTexture.animation._loopMode = false;

				self.appendDrawable(itemBtn);

				i++;
			});

			self.appendDrawable(backBtn);
			self.appendDrawable(itemTexture);

			self.appendDrawable(goodRunOfLuckButton);
			self.appendDrawable(megaRunOfLuckButton);

			self.appendDrawable(goodRunOfLuckLabel);
			self.appendDrawable(megaRunOfLuckLabel);

			self.appendDrawable(vipClubBtn2);

			self.appendDrawable(upgradeButton);

			self.appendDrawable(SJ.registration);

			self.onScreenChange = () => {
				changeItem(currentItem);
			};
		});

		SJ.ScreensManager.screens.game = new SJ.Screen((self) => {
			self.setBackgroundColor(color(0, 0, 0, 0));

			SJ.videoBackground = new SJ.UI.Element(0, 0, 1600, 900, null, null, null, null, null, 'absolute');
			SJ.videoBackground.color = color(0, 0, 0, 200);
			SJ.videoBackground.drawColorBackground = true;
			SJ.videoBackground.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			SJ.videoBackground.hide();

			SJ.darkBackgroundCourtine = new SJ.DrawableRect(
				0,
				0,
				SJ.SCREEN_WIDTH,
				SJ.SCREEN_HEIGHT,
				color(0, 0, 0, 200)
			);
			SJ.darkBackgroundCourtine.hide();
			self.appendDrawable(SJ.darkBackgroundCourtine);

			self.appendDrawable(SJ.userDataBar);

			SJ.pauseMenu = new SJ.PauseMenu();
			self.appendDrawable(SJ.pauseMenu);

			SJ.itemsDisplay = new SJ.ItemsDisplay();
			self.appendDrawable(SJ.itemsDisplay);

			self.appendDrawable(new SJ.WindDisplay());

			self.appendDrawable(new SJ.SpeedDisplay());
			self.appendDrawable(new SJ.HeightDisplay());

			SJ.jumpScoreDisplay = new SJ.JumpScoreDisplay();
			self.appendDrawable(SJ.jumpScoreDisplay);

			SJ.jumpParamDisplay = new SJ.JumpParamDisplay();
			self.appendDrawable(SJ.jumpParamDisplay);

			SJ.mapRecordDisplay = new SJ.MapRecordDisplay();
			self.appendDrawable(SJ.mapRecordDisplay);

			SJ.medalDisplay = new SJ.MedalDisplay();
			self.appendDrawable(SJ.medalDisplay);

			SJ.newRankDisplay = new SJ.NewRankDisplay();
			self.appendDrawable(SJ.newRankDisplay);

			SJ.coachDisplay = new SJ.CoachDisplay();
			self.appendDrawable(SJ.coachDisplay);

			SJ.registerDisplay = new SJ.RegisterDisplay();
			self.appendDrawable(SJ.registerDisplay);

			SJ.steeringInfoDisplay = new SJ.SteeringInfoDisplay();
			self.appendDrawable(SJ.steeringInfoDisplay);

			SJ.mobileSwipeSteeringInfo = new SJ.MobileSwipeSteeringInfo();
			self.appendDrawable(SJ.mobileSwipeSteeringInfo);

			self.appendDrawable(SJ.registration);

			self.appendDrawable(SJ.videoBackground);
		});

		SJ.ScreensManager.screens.fameGallery = new SJ.Screen(function (self) {
			const fameGallerySS = SJ.fameGallerySS;
			const fameGallerySS2 = SJ.fameGallerySS2;

			SJ.dragDisable = false;

			const background = new SJ.Texture(
				'../sj-graphics/UI/fame-gallery/background.png',
				0,
				0
			);
			const tableMainTextrue = new SJ.Texture(
				'../sj-graphics/UI/fame-gallery/table-main-graphic.png',
				0,
				0
			);
			const worldCupMainTexture = new SJ.Texture(
				'../sj-graphics/UI/fame-gallery/world-cup-main-texture.png',
				0,
				5
			);
			const tournamentMainTexture = new SJ.Texture(
				'../sj-graphics/UI/fame-gallery/tournament-main-texture.png',
				0,
				5
			);
			const bestJumpsMainTexture = new SJ.Texture(
				'../sj-graphics/UI/fame-gallery/best-jumps-main-texture.png',
				0,
				5
			);

			let curRankType = '';
			let curLocation = 'global';

			let sortBy = 'totalScore';
			let filterBy = 'jumpScore';

			const backBtn = new BackToMenuBtn(127, 172);
			backBtn.workingName = 'foo';

			const rankTypeBtnLayout = new SJ.Layout(708, 170, [], 45, 'row');

			const worldCupBtn = new SJ.TextureButton(
				0,
				0,
				null,
				new SJ.SpriteSheetTexture(
					fameGallerySS2,
					0,
					0,
					null,
					null,
					958,
					74,
					281,
					78
				),
				new SJ.SpriteSheetTexture(
					fameGallerySS2,
					0,
					0,
					null,
					null,
					301,
					257,
					311,
					108
				)
			);
			worldCupBtn.onMousePress = () => {
				sortBy = 'totalScore';
				filterBy = 'jumpScore';
				setCurRankType('WorldCup');
				loadRank(curRankType, curLocation);
			};
			worldCupBtn.workingName = 'WorldCup';

			const tournamentBtn = new SJ.TextureButton(
				0,
				0,
				null,
				new SJ.SpriteSheetTexture(
					fameGallerySS2,
					0,
					0,
					null,
					null,
					686,
					74,
					272,
					78
				),
				new SJ.SpriteSheetTexture(
					fameGallerySS2,
					0,
					0,
					null,
					null,
					0,
					257,
					301,
					107
				)
			);
			tournamentBtn.onMousePress = () => {
				sortBy = 'totalScore';
				filterBy = 'jumpScore';
				setCurRankType('Tournament');
				loadRank(curRankType, curLocation);
			};
			tournamentBtn.workingName = 'Tournament';

			const bestJumpsBtn = new SJ.TextureButton(
				0,
				0,
				null,
				new SJ.SpriteSheetTexture(
					fameGallerySS2,
					0,
					0,
					null,
					null,
					193,
					74,
					281,
					77
				),
				new SJ.SpriteSheetTexture(
					fameGallerySS2,
					0,
					0,
					null,
					null,
					1519,
					152,
					310,
					105
				)
			);
			bestJumpsBtn.onMousePress = () => {
				sortBy = 'jumpDistance';
				filterBy = 'jumpDistance';

				this.sortByJumpDistanceBtn.forceHoverTexure = true;

				setCurRankType('Jumps');
				loadRank(curRankType, curLocation);
			};
			bestJumpsBtn.workingName = 'Jumps';

			rankTypeBtnLayout.addChild(worldCupBtn);
			rankTypeBtnLayout.addChild(tournamentBtn);
			rankTypeBtnLayout.addChild(bestJumpsBtn);

			this.sortByJumpDistanceBtn = new SJ.TextureButton(
				0,
				0,
				null,
				new SJ.SpriteSheetTexture(
					fameGallerySS2,
					0,
					0,
					null,
					null,
					128,
					0,
					35,
					19
				),
				new SJ.SpriteSheetTexture(
					fameGallerySS2,
					0,
					0,
					null,
					null,
					198,
					0,
					44,
					25
				),
				null,
				null,
				null,
				() => {
					sortBy = 'jumpDistance';
					filterBy = 'jumpDistance';
					loadRank(curRankType, curLocation);

					this.sortByJumpDistanceBtn.forceHoverTexure = true;
					this.sortByJumpScoreBtn.forceHoverTexure = false;
				}
			);

			this.sortByJumpScoreBtn = new SJ.TextureButton(
				0,
				0,
				null,
				new SJ.SpriteSheetTexture(
					fameGallerySS2,
					0,
					0,
					null,
					null,
					163,
					0,
					35,
					19
				),
				new SJ.SpriteSheetTexture(
					fameGallerySS2,
					0,
					0,
					null,
					null,
					198,
					0,
					44,
					25
				),
				null,
				null,
				null,
				() => {
					sortBy = 'jumpScore';
					filterBy = 'jumpScore';

					loadRank(curRankType, curLocation);

					this.sortByJumpDistanceBtn.forceHoverTexure = false;
					this.sortByJumpScoreBtn.forceHoverTexure = true;
				}
			);

			const sortBtnsLayout = new SJ.Layout(
				1465,
				375,
				[this.sortByJumpScoreBtn, this.sortByJumpDistanceBtn],
				10,
				'row',
				CENTER
			);
			sortBtnsLayout.workingName = 'srtBtns';

			const globalBtn = new SJ.TextureButton(
				45,
				265,
				null,
				new SJ.SpriteSheetTexture(
					fameGallerySS2,
					0,
					0,
					null,
					null,
					0,
					74,
					193,
					61
				),
				new SJ.SpriteSheetTexture(
					fameGallerySS2,
					0,
					0,
					null,
					null,
					474,
					74,
					212,
					78
				)
			);
			globalBtn.onMousePress = () => {
				setCurLocation('global');
				loadRank(curRankType, curLocation);
			};

			const mapButtonsLayout = new SJ.Layout(270, 292, [], 48, 'row');

			const mapBtnHover = new SJ.SpriteSheetTexture(
				fameGallerySS2,
				0,
				0,
				null,
				null,
				474,
				74,
				212,
				78
			);

			const mapsArray = [
				{ name: 'Szczyrk', x: 0, y: 291 },
				{ name: 'Oberstdorf', x: 494, y: 169 },
				{ name: 'Zakopane', x: 579, y: 291 },
				{ name: 'Vikersund', x: 386, y: 291 },
				{ name: 'Planica', x: 579, y: 230 },
				{ name: 'Pekin 2030', x: 386, y: 230 },
			];

			mapsArray.forEach((map) => {
				const btn = new SJ.TextureButton(
					0,
					0,
					null,
					new SJ.SpriteSheetTexture(
						fameGallerySS,
						0,
						0,
						null,
						null,
						map.x,
						map.y,
						193,
						61
					),
					mapBtnHover
				);

				btn.onMousePress = () => {
					setCurLocation(map.name);
					loadRank(curRankType, curLocation);
				};
				btn.workingName = map.name;

				mapButtonsLayout.addChild(btn);
			});

			const tournamentButtonsLayout = new SJ.Layout(270, 292, [], 48, 'row');
			mapButtonsLayout.workingName = 't';

			const tournamentArray = [
				{ name: 'PUCHAR FIS', x: 687, y: 169 },
				{ name: 'PUCHAR KONTYNENTALNY', x: 0, y: 230 },
				{ name: 'MISTRZOSTWA ŚWIATA', x: 108, y: 169 },
				{ name: 'PUCHAR ŚWIATA W LOTACH', x: 193, y: 230 },
				{ name: 'TURNIEJ CZTERECH SKOCZNI', x: 193, y: 291 },
				{ name: 'MISTRZOSWA ŚWIATA W LOTACH', x: 301, y: 169 },
			];

			tournamentArray.forEach((tournament) => {
				const btn = new SJ.TextureButton(
					0,
					0,
					null,
					new SJ.SpriteSheetTexture(
						fameGallerySS,
						0,
						0,
						null,
						null,
						tournament.x,
						tournament.y,
						193,
						61
					),
					mapBtnHover
				);
				btn.workingName = tournament.name;

				btn.onMousePress = () => {
					// if(tournament.name === 'MISTRZOSWA ŚWIATA W LOTACH'){
					//   if(!SJ.playerData.data['isVip'] && SJ.playerData.data['name'] !== 'Guest'){
					//     SJ.ScreensManager.changeScreen(SJ.ScreensManager.screens.vipClub);
					//     SJ.mainMenuSoundContainer.play('VIPClub');
					//   }
					//   else if(SJ.playerData.data['name'] !== 'Guest' && SJ.playerData.data['isVip']){
					//     setCurLocation(tournament.name);
					//     loadRank(curRankType, curLocation);
					//   }
					// }else{
					//   setCurLocation(tournament.name);
					//   loadRank(curRankType, curLocation);
					// }

					setCurLocation(tournament.name);
					loadRank(curRankType, curLocation);
				};

				tournamentButtonsLayout.addChild(btn);
			});

			const rankDisplay = new SJ.RankDisplay(
				37,
				350,
				[],
				[],
				[],
				tableMainTextrue,
				worldCupMainTexture,
				tournamentMainTexture,
				bestJumpsMainTexture
			);

			const setCurLocation = (newLocation) => {
				curLocation = newLocation;

				if (curLocation === 'global') globalBtn.forceHoverTexure = true;
				else globalBtn.forceHoverTexure = false;

				if (curRankType === 'Tournament') {
					tournamentButtonsLayout.children.forEach((child) => {
						child.forceHoverTexure = false;
					});

					tournamentButtonsLayout.children.forEach((child) => {
						if (child.workingName === curLocation)
							child.forceHoverTexure = true;
					});
				} else {
					mapButtonsLayout.children.forEach((child) => {
						child.forceHoverTexure = false;
					});

					mapButtonsLayout.children.forEach((child) => {
						if (child.workingName === curLocation)
							child.forceHoverTexure = true;
					});
				}
			};
			setCurLocation('global');

			const setCurRankType = (newRankType) => {
				curRankType = newRankType;

				setCurLocation('global');

				if (curRankType === 'Tournament') {
					mapButtonsLayout.hide();
					tournamentButtonsLayout.show();
				} else {
					mapButtonsLayout.show();
					tournamentButtonsLayout.hide();
				}

				rankTypeBtnLayout.children.forEach((child) => {
					child.forceHoverTexure = false;
				});

				rankTypeBtnLayout.children.forEach((child) => {
					if (child.workingName === curRankType) child.forceHoverTexure = true;
				});

				if (curRankType !== 'Jumps') {
					this.sortByJumpDistanceBtn.hide();
					this.sortByJumpScoreBtn.hide();
				} else {
					this.sortByJumpDistanceBtn.show();
					this.sortByJumpScoreBtn.show();
				}
			};
			setCurRankType('WorldCup');

			const loadRank = (rankType, location) => {
				let url = '';

				if (location === 'global')
					url = `${SJ.APILink}rank/getGlobal${rankType}Rank.php`;
				else if (rankType === 'WorldCup' || rankType === 'Jumps')
					url = `${SJ.APILink}rank/getSingleMap${rankType}Rank.php?mapName=${location}`;
				else if (rankType === 'Tournament')
					url = `${SJ.APILink}rank/getSingleMapTournamentRank.php?tournamentName=${location}`;

				const itemsUrl = `${SJ.APILink}rank/getItemsInfoToRank.php`;
				const medalsUrl = `${SJ.APILink}rank/getMedals.php`;

				SJ.ImageLoader.remainingToLoad++;

				fetch(url)
					.then((res) => {
						return res.json();
					})
					.then((rankData) => {
						fetch(itemsUrl)
							.then((res) => {
								return res.json();
							})
							.then((itemsData) => {
								fetch(medalsUrl)
									.then((res) => {
										return res.json();
									})
									.then((medalsData) => {
										rankDisplay.pageIndex = 0;
										rankDisplay.pageIndexLabel.content =
											rankDisplay.pageIndex * 100;

										rankDisplay.scrollY = 0;
										rankDisplay.changeScrollGraphicPosition();

										rankDisplay.updateRankData(
											rankData,
											itemsData,
											medalsData,
											rankType,
											sortBy,
											filterBy
										);

										SJ.ImageLoader.remainingToLoad--;
									});
							});
					});
			};

			const loadingWindow = new SJ.LoadingWindow();

			self.appendDrawable(background);
			self.appendDrawable(backBtn);

			self.appendDrawable(rankTypeBtnLayout);

			self.appendDrawable(mapButtonsLayout);
			self.appendDrawable(tournamentButtonsLayout);

			self.appendDrawable(globalBtn);

			self.appendDrawable(rankDisplay);

			self.appendDrawable(sortBtnsLayout);

			self.appendDrawable(SJ.userDataBar);
			self.appendDrawable(SJ.registration);

			self.appendDrawable(loadingWindow);

			self.onScreenChange = () => {
				loadRank(curRankType, curLocation);
			};

			loadRank(curRankType, curLocation);
		});

		// SJ.ScreensManager.screens.rank = new SJ.Screen((self) => {
		// 	const buttonWidth = 130;
		// 	const buttonHeight = 30;
		// 	const buttonsY = 150;
		// 	const buttonSpacing = 40;
		// 	const margin = 60;

		// 	let rankPage = 0;
		// 	let sortBy = 'totalScore';

		// 	let rankArrayLength = 0;

		// 	const changeRank = (url, location) => {
		// 		const rankPosInDrawableArray = self._drawable.length - 2;
		// 		self._drawable[rankPosInDrawableArray] = new SJ.Label(
		// 			'ŁADOWANIE',
		// 			SJ.SCREEN_MIDDLE_X,
		// 			SJ.SCREEN_MIDDLE_Y,
		// 			CENTER,
		// 			CENTER,
		// 			26
		// 		);
		// 		fetch(url)
		// 			.then((res) => {
		// 				return res.json();
		// 			})
		// 			.then((rankArray) => {
		// 				fetch(`${SJ.APILink}rank/getItemsInfoToRank.php`)
		// 					.then((res) => {
		// 						return res.json();
		// 					})
		// 					.then((itemsInfoArray) => {
		// 						fetch(`${SJ.APILink}rank/getMedals.php`)
		// 							.then((res) => {
		// 								return res.json();
		// 							})
		// 							.then((medalsInfoArray) => {
		// 								const newRankDisplay = new SJ.RankDisplay(
		// 									margin,
		// 									20,
		// 									SJ.SCREEN_WIDTH - 100,
		// 									14,
		// 									rankArray,
		// 									itemsInfoArray,
		// 									medalsInfoArray,
		// 									location,
		// 									rankPage
		// 								);

		// 								self._drawable[rankPosInDrawableArray] = newRankDisplay;
		// 								rankArrayLength = rankArray.length;

		// 								self.lookForAbsolutes(newRankDisplay);
		// 							});
		// 					});
		// 			})
		// 			.catch((error) => {
		// 				console.log(`${error}`);
		// 			});
		// 	};

		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'^',
		// 			SJ.SCREEN_WIDTH - 50,
		// 			SJ.SCREEN_MIDDLE_Y - 25,
		// 			30,
		// 			30,
		// 			() => {
		// 				if (rankPage > 0) {
		// 					rankPage--;
		// 					self._drawable[self._drawable.length - 2].getRowsPage(rankPage);
		// 					// console.log(rankPage);
		// 				}
		// 			}
		// 		)
		// 	);
		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'v',
		// 			SJ.SCREEN_WIDTH - 50,
		// 			SJ.SCREEN_MIDDLE_Y + 25,
		// 			30,
		// 			30,
		// 			() => {
		// 				rankPage++;
		// 				self._drawable[self._drawable.length - 2].getRowsPage(rankPage);
		// 				// console.log(rankPage);
		// 			}
		// 		)
		// 	);

		// 	const typeButtonsWidth = 450;
		// 	const typeButtonsHeight = 50;

		// 	self.appendDrawable(
		// 		new SJ.Label(
		// 			'PUCHAR ŚWIATA',
		// 			SJ.SCREEN_MIDDLE_X,
		// 			50,
		// 			CENTER,
		// 			CENTER,
		// 			38
		// 		)
		// 	);

		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'GLOBAL',
		// 			margin,
		// 			buttonsY,
		// 			buttonWidth,
		// 			buttonHeight,
		// 			null,
		// 			() => {
		// 				const url = `${SJ.APILink}rank/getGlobalWorldCupRank.php`;
		// 				changeRank(url, 'Global');
		// 			}
		// 		)
		// 	);

		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'SZCZYRK',
		// 			buttonWidth + buttonSpacing + margin,
		// 			buttonsY,
		// 			buttonWidth,
		// 			buttonHeight,
		// 			null,
		// 			() => {
		// 				const url = `${SJ.APILink}rank/getSingleMapRank.php?mapName=Szczyrk`;
		// 				changeRank(url, 'Szczyrk');
		// 			}
		// 		)
		// 	);

		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'OBERSTDORF',
		// 			(buttonWidth + buttonSpacing) * 2 + margin,
		// 			buttonsY,
		// 			buttonWidth,
		// 			buttonHeight,
		// 			null,
		// 			() => {
		// 				const url = `${SJ.APILink}rank/getSingleMapRank.php?mapName=Oberstdorf`;
		// 				changeRank(url, 'Oberstdorf');
		// 			}
		// 		)
		// 	);

		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'ZAKOPANE',
		// 			(buttonWidth + buttonSpacing) * 3 + margin,
		// 			buttonsY,
		// 			buttonWidth,
		// 			buttonHeight,
		// 			null,
		// 			() => {
		// 				const url = `${SJ.APILink}rank/getSingleMapRank.php?mapName=Zakopane`;
		// 				changeRank(url, 'Zakopane');
		// 			}
		// 		)
		// 	);

		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'VIKERSUND',
		// 			(buttonWidth + buttonSpacing) * 4 + margin,
		// 			buttonsY,
		// 			buttonWidth,
		// 			buttonHeight,
		// 			null,
		// 			() => {
		// 				const url = `${SJ.APILink}rank/getSingleMapRank.php?mapName=Vikersund`;
		// 				changeRank(url, 'Vikersund');
		// 			}
		// 		)
		// 	);

		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'PLANICA',
		// 			(buttonWidth + buttonSpacing) * 5 + margin,
		// 			buttonsY,
		// 			buttonWidth,
		// 			buttonHeight,
		// 			null,
		// 			() => {
		// 				const url = `${SJ.APILink}rank/getSingleMapRank.php?mapName=Planica`;
		// 				changeRank(url, 'Vikersund');
		// 			}
		// 		)
		// 	);

		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'PEKIN 2030',
		// 			(buttonWidth + buttonSpacing) * 6 + margin,
		// 			buttonsY,
		// 			buttonWidth,
		// 			buttonHeight,
		// 			null,
		// 			() => {
		// 				const url = `${SJ.APILink}rank/getSingleMapRank.php?mapName=Pekin 2030`;
		// 				changeRank(url, 'Vikersund');
		// 			}
		// 		)
		// 	);

		// 	self.onScreenChange = () => {
		// 		console.log('rank');
		// 		const url = `${SJ.APILink}rank/getGlobalWorldCupRank.php`;
		// 		changeRank(url, 'Global');
		// 	};

		// 	self.appendDrawable(new SJ.Label('', 0, 0));
		// 	self.appendDrawable(backBtn);
		// });

		// SJ.ScreensManager.screens.jumpsRank = new SJ.Screen((self) => {
		// 	const buttonWidth = 130;
		// 	const buttonHeight = 30;
		// 	const buttonsY = 150;
		// 	const buttonSpacing = 40;
		// 	const margin = 60;

		// 	let rankPage = 0;

		// 	let sortBy = 'jumpScore';
		// 	let filterBy = 'jumpScore';
		// 	let rankType = 'score';

		// 	let rankArrayLength = 0;

		// 	const changeRank = (url, location) => {
		// 		const rankPosInDrawableArray = self._drawable.length - 2;
		// 		self._drawable[rankPosInDrawableArray] = new SJ.Label(
		// 			'ŁADOWANIE',
		// 			SJ.SCREEN_MIDDLE_X,
		// 			SJ.SCREEN_MIDDLE_Y,
		// 			CENTER,
		// 			CENTER,
		// 			26
		// 		);
		// 		fetch(url)
		// 			.then((res) => {
		// 				return res.json();
		// 			})
		// 			.then((rankArray) => {
		// 				fetch(`${SJ.APILink}rank/getItemsInfoToRank.php`)
		// 					.then((res) => {
		// 						return res.json();
		// 					})
		// 					.then((itemsInfoArray) => {
		// 						fetch(`${SJ.APILink}rank/getMedals.php`)
		// 							.then((res) => {
		// 								return res.json();
		// 							})
		// 							.then((medalsInfoArray) => {
		// 								self._drawable[rankPosInDrawableArray] = new SJ.RankDisplay(
		// 									margin,
		// 									20,
		// 									SJ.SCREEN_WIDTH - 100,
		// 									14,
		// 									rankArray,
		// 									itemsInfoArray,
		// 									medalsInfoArray,
		// 									location,
		// 									rankPage,
		// 									sortBy,
		// 									filterBy,
		// 									rankType
		// 								);
		// 								rankArrayLength = rankArray.length;
		// 							});
		// 					});
		// 			})
		// 			.catch((error) => {
		// 				console.log(`${error}`);
		// 			});
		// 	};

		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'^',
		// 			SJ.SCREEN_WIDTH - 50,
		// 			SJ.SCREEN_MIDDLE_Y - 25,
		// 			30,
		// 			30,
		// 			() => {
		// 				if (rankPage > 0) {
		// 					rankPage--;
		// 					self._drawable[self._drawable.length - 2].getRowsPage(rankPage);
		// 					// console.log(rankPage);
		// 				}
		// 			}
		// 		)
		// 	);
		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'v',
		// 			SJ.SCREEN_WIDTH - 50,
		// 			SJ.SCREEN_MIDDLE_Y + 25,
		// 			30,
		// 			30,
		// 			() => {
		// 				rankPage++;
		// 				self._drawable[self._drawable.length - 2].getRowsPage(rankPage);
		// 				// console.log(rankPage);
		// 			}
		// 		)
		// 	);

		// 	const typeButtonsWidth = 450;
		// 	const typeButtonsHeight = 50;

		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'RANKING SKOKÓW(punkty)',
		// 			SJ.SCREEN_MIDDLE_X - typeButtonsWidth - 20,
		// 			80,
		// 			typeButtonsWidth,
		// 			typeButtonsHeight,
		// 			null,
		// 			() => {
		// 				sortBy = 'jumpScore';
		// 				filterBy = 'jumpScore';
		// 				rankType = 'score';

		// 				self._drawable[self._drawable.length - 2].filterRankArray(
		// 					filterBy,
		// 					rankType
		// 				);
		// 				self._drawable[self._drawable.length - 2].sortRows(sortBy);
		// 			}
		// 		)
		// 	);

		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'RANKING SKOKÓW(odległość)',
		// 			SJ.SCREEN_MIDDLE_X + 20,
		// 			80,
		// 			typeButtonsWidth,
		// 			typeButtonsHeight,
		// 			null,
		// 			() => {
		// 				sortBy = 'jumpDistance';
		// 				filterBy = 'jumpDistance';
		// 				rankType = 'distance';

		// 				self._drawable[self._drawable.length - 2].filterRankArray(
		// 					filterBy,
		// 					rankType
		// 				);
		// 				self._drawable[self._drawable.length - 2].sortRows(sortBy);
		// 			}
		// 		)
		// 	);

		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'GLOBAL',
		// 			margin,
		// 			buttonsY,
		// 			buttonWidth,
		// 			buttonHeight,
		// 			null,
		// 			() => {
		// 				const url = `${SJ.APILink}rank/getGlobalJumpsRank.php`;
		// 				changeRank(url, 'Global');
		// 			}
		// 		)
		// 	);

		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'SZCZYRK',
		// 			buttonWidth + buttonSpacing + margin,
		// 			buttonsY,
		// 			buttonWidth,
		// 			buttonHeight,
		// 			null,
		// 			() => {
		// 				const url = `${SJ.APILink}rank/getSingleMapJumpsRank.php?mapName=Szczyrk`;
		// 				changeRank(url, 'Szczyrk');
		// 			}
		// 		)
		// 	);

		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'OBERSTDORF',
		// 			(buttonWidth + buttonSpacing) * 2 + margin,
		// 			buttonsY,
		// 			buttonWidth,
		// 			buttonHeight,
		// 			null,
		// 			() => {
		// 				const url = `${SJ.APILink}rank/getSingleMapJumpsRank.php?mapName=Oberstdorf`;
		// 				changeRank(url, 'Oberstdorf');
		// 			}
		// 		)
		// 	);

		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'ZAKOPANE',
		// 			(buttonWidth + buttonSpacing) * 3 + margin,
		// 			buttonsY,
		// 			buttonWidth,
		// 			buttonHeight,
		// 			null,
		// 			() => {
		// 				const url = `${SJ.APILink}rank/getSingleMapJumpsRank.php?mapName=Zakopane`;
		// 				changeRank(url, 'Zakopane');
		// 			}
		// 		)
		// 	);

		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'VIKERSUND',
		// 			(buttonWidth + buttonSpacing) * 4 + margin,
		// 			buttonsY,
		// 			buttonWidth,
		// 			buttonHeight,
		// 			null,
		// 			() => {
		// 				const url = `${SJ.APILink}rank/getSingleMapJumpsRank.php?mapName=Vikersund`;
		// 				changeRank(url, 'Vikersund');
		// 			}
		// 		)
		// 	);

		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'PLANICA',
		// 			(buttonWidth + buttonSpacing) * 5 + margin,
		// 			buttonsY,
		// 			buttonWidth,
		// 			buttonHeight,
		// 			null,
		// 			() => {
		// 				const url = `${SJ.APILink}rank/getSingleMapJumpsRank.php?mapName=Planica`;
		// 				changeRank(url, 'Vikersund');
		// 			}
		// 		)
		// 	);

		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'PEKIN 2030',
		// 			(buttonWidth + buttonSpacing) * 6 + margin,
		// 			buttonsY,
		// 			buttonWidth,
		// 			buttonHeight,
		// 			null,
		// 			() => {
		// 				const url = `${SJ.APILink}rank/getSingleMapJumpsRank.php?mapName=Pekin 2030`;
		// 				changeRank(url, 'Vikersund');
		// 			}
		// 		)
		// 	);

		// 	self.onScreenChange = () => {
		// 		console.log('jumpRank');
		// 		const url = `${SJ.APILink}rank/getGlobalJumpsRank.php`;
		// 		changeRank(url, 'Global');
		// 	};

		// 	self.appendDrawable(new SJ.Label('', 0, 0));
		// 	self.appendDrawable(backBtn);
		// });

		// SJ.ScreensManager.screens.tournamentRank = new SJ.Screen((self) => {
		// 	let rankPage = 0;
		// 	const rankPosInDrawableArray = 0;

		// 	const buttonWidth = 350;
		// 	const buttonHeight = 30;
		// 	const buttonsY = 130;
		// 	const buttonXSpacing = 40;
		// 	const buttonYSpacing = 20;
		// 	const margin = 75;

		// 	const loadRank = (url) => {
		// 		rank = new SJ.Label(
		// 			'ŁADOWANIE',
		// 			SJ.SCREEN_MIDDLE_X,
		// 			SJ.SCREEN_MIDDLE_Y,
		// 			CENTER,
		// 			CENTER,
		// 			26
		// 		);
		// 		fetch(url)
		// 			.then((res) => {
		// 				return res.json();
		// 			})
		// 			.then((rankArray) => {
		// 				// console.log(rankArray);
		// 				fetch(`${SJ.APILink}rank/getItemsInfoToRank.php`)
		// 					.then((res) => {
		// 						return res.json();
		// 					})
		// 					.then((itemsInfoArray) => {
		// 						fetch(`${SJ.APILink}rank/getMedals.php`)
		// 							.then((res) => {
		// 								return res.json();
		// 							})
		// 							.then((medalsInfoArray) => {
		// 								self._drawable[rankPosInDrawableArray] = new SJ.RankDisplay(
		// 									margin,
		// 									20,
		// 									SJ.SCREEN_WIDTH - 100,
		// 									14,
		// 									rankArray,
		// 									itemsInfoArray,
		// 									medalsInfoArray,
		// 									location,
		// 									rankPage
		// 								);
		// 							});
		// 					});
		// 			})
		// 			.catch((error) => {
		// 				console.log(`${error}`);
		// 			});
		// 	};

		// 	const createTournamentButtons = () => {
		// 		fetch(`${SJ.APILink}tournaments/getAll.php`)
		// 			.then((res) => {
		// 				return res.json();
		// 			})
		// 			.then((res) => {
		// 				let i = 0;
		// 				let ySpacingMuliplier = 0;

		// 				res.forEach((tournament) => {
		// 					let tBtn = new SJ.Button(
		// 						tournament.name,
		// 						(buttonWidth + buttonXSpacing) * i + margin,
		// 						buttonsY + (buttonHeight + buttonYSpacing) * ySpacingMuliplier,
		// 						buttonWidth,
		// 						buttonHeight,
		// 						null,
		// 						() => {
		// 							loadRank(
		// 								`${SJ.APILink}rank/getSingleTournamentRank.php?tournamentName=${tournament.name}`
		// 							);
		// 						}
		// 					);
		// 					tBtn.label.fontSize = 18;

		// 					self.appendDrawable(tBtn);

		// 					i++;
		// 					if (i > 2) {
		// 						i = 0;
		// 						ySpacingMuliplier++;
		// 					}
		// 				});
		// 			});
		// 	};

		// 	self.rank = new SJ.Label(
		// 		'ŁADOWANIE',
		// 		SJ.SCREEN_MIDDLE_X,
		// 		SJ.SCREEN_MIDDLE_Y,
		// 		CENTER,
		// 		CENTER,
		// 		26
		// 	);
		// 	self.appendDrawable(self.rank);

		// 	self.appendDrawable(
		// 		new SJ.Label(
		// 			'RANKING TURNIEJOWY',
		// 			SJ.SCREEN_MIDDLE_X,
		// 			50,
		// 			CENTER,
		// 			CENTER,
		// 			36
		// 		)
		// 	);

		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'GLOBALNY',
		// 			SJ.SCREEN_MIDDLE_X - buttonWidth / 2,
		// 			80,
		// 			buttonWidth,
		// 			buttonHeight,
		// 			null,
		// 			() => {
		// 				loadRank(`${SJ.APILink}rank/getGlobalTournamentRank.php`);
		// 			}
		// 		)
		// 	);

		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'^',
		// 			SJ.SCREEN_WIDTH - 50,
		// 			SJ.SCREEN_MIDDLE_Y - 25,
		// 			30,
		// 			30,
		// 			() => {
		// 				if (rankPage > 0) {
		// 					rankPage--;
		// 					self._drawable[rankPosInDrawableArray].getRowsPage(rankPage);
		// 					// console.log(rankPage);
		// 				}
		// 			}
		// 		)
		// 	);

		// 	self.appendDrawable(
		// 		new SJ.Button(
		// 			'v',
		// 			SJ.SCREEN_WIDTH - 50,
		// 			SJ.SCREEN_MIDDLE_Y + 25,
		// 			30,
		// 			30,
		// 			() => {
		// 				rankPage++;
		// 				self._drawable[rankPosInDrawableArray].getRowsPage(rankPage);
		// 				// console.log(rankPage);
		// 			}
		// 		)
		// 	);

		// 	self.appendDrawable(backBtn);

		// 	self.onScreenChange = () => {
		// 		console.log('tournamentRank');
		// 		createTournamentButtons();
		// 		loadRank(`${SJ.APILink}rank/getGlobalTournamentRank.php`);
		// 	};
		// });

		SJ.ScreensManager.screens.career = new SJ.Screen((self) => {
			const renderScreen = (
				medalsData,
				userData,
				bestJumpData,
				globalMapRankPosition,
				tournamentGlobalRankingPosition
			) => {
				self._drawable = [];

				const mainGraphic = new SJ.Texture(
					'../sj-graphics/UI/career-screen/main-graphic.png'
				);
				const careerScreenSS = SJ.ImageLoader.load(
					'UI/career-screen/careerScreenSS.png'
				);

				const backBtn = new BackToMenuBtn(72, 259);

				const soonLabel = new SJ.SpriteSheetTexture(
					careerScreenSS,
					363.5,
					388.5,
					null,
					null,
					178,
					98,
					151,
					55
				);
				soonLabel.hide();

				const challengesBtn = new SJ.TextureButton(
					797,
					816,
					null,
					new SJ.SpriteSheetTexture2(
						careerScreenSS,
						0,
						0,
						null,
						null,
						0,
						47,
						166,
						47
					),
					null,
					null,
					null,
					null,
					null,
					null,
					() => soonLabel.show(),
					() => soonLabel.hide()
				);

				const bestJumpsBtn = new SJ.TextureButton(
					987,
					816,
					null,
					new SJ.SpriteSheetTexture2(
						careerScreenSS,
						0,
						0,
						null,
						null,
						702,
						0,
						315,
						47
					),
					null,
					null,
					null,
					null,
					null
				);

				const rankDisplayData = [
					{
						sprites: {
							image: { x: 617, y: 200, w: 111, h: 103 },
							'image-1': { x: 284, y: 200, w: 111, h: 103 },
							'image-2': { x: 395, y: 200, w: 111, h: 103 },
							'image-3': { x: 506, y: 200, w: 111, h: 103 },
						},
						x: 166,
						y: 663,
					},
					{
						sprites: {
							image: { x: 142, y: 200, w: 142, h: 102 },
							'image-1': { x: 632, y: 98, w: 142, h: 102 },
							'image-2': { x: 774, y: 98, w: 142, h: 102 },
							'image-3': { x: 0, y: 200, w: 142, h: 102 },
						},
						x: 316,
						y: 630,
					},
					{
						sprites: {
							image: { x: 0, y: 549, w: 132, h: 124 },
							'image-1': { x: 339, y: 425, w: 132, h: 124 },
							'image-2': { x: 603, y: 425, w: 132, h: 124 },
							'image-3': { x: 867, y: 425, w: 132, h: 124 },
						},
						x: 481,
						y: 598,
					},
					{
						sprites: {
							image: { x: 226, y: 425, w: 113, h: 122 },
							'image-1': { x: 895, y: 303, w: 113, h: 122 },
							'image-2': { x: 0, y: 425, w: 113, h: 122 },
							'image-3': { x: 113, y: 425, w: 113, h: 122 },
						},
						x: 649,
						y: 560,
					},
					{
						sprites: {
							image: { x: 782, y: 303, w: 113, h: 122 },
							'image-1': { x: 443, y: 303, w: 113, h: 122 },
							'image-2': { x: 556, y: 303, w: 113, h: 122 },
							'image-3': { x: 669, y: 303, w: 113, h: 122 },
						},
						x: 42,
						y: 515,
					},
					{
						sprites: {
							image: { x: 549, y: 549, w: 139, h: 126 },
							'image-1': { x: 132, y: 549, w: 139, h: 126 },
							'image-2': { x: 271, y: 549, w: 139, h: 126 },
							'image-3': { x: 410, y: 549, w: 139, h: 126 },
						},
						x: 169,
						y: 476,
					},
					{
						sprites: {
							image: { x: 0, y: 679, w: 99, h: 130 },
							'image-1': { x: 688, y: 549, w: 99, h: 130 },
							'image-2': { x: 787, y: 549, w: 99, h: 130 },
							'image-3': { x: 886, y: 549, w: 99, h: 130 },
						},
						x: 337,
						y: 421,
					},
					{
						sprites: {
							image: { x: 402, y: 679, w: 101, h: 131 },
							'image-1': { x: 99, y: 679, w: 101, h: 131 },
							'image-2': { x: 200, y: 679, w: 101, h: 131 },
							'image-3': { x: 301, y: 679, w: 101, h: 131 },
						},
						x: 478,
						y: 386,
					},
					{
						sprites: {
							image: { x: 821, y: 679, w: 106, h: 145 },
							'image-1': { x: 503, y: 679, w: 106, h: 145 },
							'image-2': { x: 609, y: 679, w: 106, h: 145 },
							'image-3': { x: 715, y: 679, w: 106, h: 145 },
						},
						x: 619,
						y: 336,
					},
					{
						sprites: {
							image: { x: 429, y: 824, w: 143, h: 191 },
							'image-1': { x: 0, y: 824, w: 143, h: 191 },
							'image-2': { x: 143, y: 824, w: 143, h: 191 },
							'image-3': { x: 286, y: 824, w: 143, h: 191 },
						},
						x: 314,
						y: 133,
					},
				];

				const bestJumpsDisplay = new SJ.UserCareerBestJumpsDisplay(
					bestJumpData,
					careerScreenSS
				);
				self.appendDrawable(bestJumpsDisplay);

				// console.log(medalsData);
				// console.log(userData);

				const getMostExpensiveMedal = (data) => {
					let mostExpensiveMedal = data[0];

					data.forEach((medal) => {
						if (
							parseInt(medal.bonusMoney) >
							parseInt(mostExpensiveMedal.bonusMoney)
						)
							mostExpensiveMedal = medal;
					});

					return mostExpensiveMedal;
				};

				const mostExpensiveMedal = getMostExpensiveMedal(medalsData);
				const mostExpensiveMedalId = mostExpensiveMedal
					? mostExpensiveMedal.id
					: null;

				const successfulJumpsLabel = new SJ.Label(
					userData['successfulJumps'],
					1460,
					833,
					LEFT,
					CENTER,
					26,
					color(255)
				);

				bestJumpsBtn.onMousePress = () => bestJumpsDisplay.show();

				self.appendDrawable(mainGraphic);
				self.appendDrawable(backBtn);
				self.appendDrawable(successfulJumpsLabel);
				self.appendDrawable(challengesBtn);
				self.appendDrawable(soonLabel);
				self.appendDrawable(bestJumpsBtn);

				let totalMedalsCount = medalsData.length;

				rankDisplayData.forEach((rank) => {
					self.appendDrawable(
						new SJ.CareerRankDisplay(
							rank.x,
							rank.y,
							totalMedalsCount,
							rank.sprites,
							careerScreenSS
						)
					);
					totalMedalsCount -= 3;
				});

				const medalsDisplayX = 1037;

				self.appendDrawable(
					new SJ.CareerMedalsDisplay(
						medalsDisplayX,
						210,
						medalsData.filter((m) => m.mapName === 'Szczyrk'),
						mostExpensiveMedalId,
						careerScreenSS
					)
				);

				self.appendDrawable(
					new SJ.CareerMedalsDisplay(
						medalsDisplayX,
						312,
						medalsData.filter((m) => m.mapName === 'Oberstdorf'),
						mostExpensiveMedalId,
						careerScreenSS
					)
				);

				self.appendDrawable(
					new SJ.CareerMedalsDisplay(
						medalsDisplayX,
						414,
						medalsData.filter((m) => m.mapName === 'Zakopane'),
						mostExpensiveMedalId,
						careerScreenSS
					)
				);

				self.appendDrawable(
					new SJ.CareerMedalsDisplay(
						medalsDisplayX,
						517,
						medalsData.filter((m) => m.mapName === 'Vikersund'),
						mostExpensiveMedalId,
						careerScreenSS
					)
				);

				self.appendDrawable(
					new SJ.CareerMedalsDisplay(
						medalsDisplayX,
						620,
						medalsData.filter((m) => m.mapName === 'Planica'),
						mostExpensiveMedalId,
						careerScreenSS
					)
				);

				self.appendDrawable(
					new SJ.CareerMedalsDisplay(
						medalsDisplayX,
						721,
						medalsData.filter((m) => m.mapName === 'Pekin 2030'),
						mostExpensiveMedalId,
						careerScreenSS
					)
				);

				self.appendDrawable(SJ.userDataBar);
				self.appendDrawable(SJ.registration);
			};

			self.onScreenChange = (userName = null) => {
				self._drawable = [];

				self.appendDrawable(new SJ.LoadingWindow());

				let url = `${SJ.APILink}user/getCareerData.php?userName=${userName || SJ.playerData.data['name']
					}`;
				fetch(url)
					.then((res) => {
						return res.json();
					})
					.then((resJson) => {
						renderScreen(
							resJson[0],
							resJson[1],
							resJson[2],
							resJson[3],
							resJson[4]
						);
						// console.log('');
						// console.log('Career data got from server');
						// console.log(resJson);
					});
			};
		});

		SJ.ScreensManager.screens.vipClub = new SJ.Screen((self) => {
			const vipClubSS = SJ.vipClubSS;

			const loadingLabel = new SJ.Label(
				'ŁADOWANIE',
				SJ.SCREEN_MIDDLE_X,
				SJ.SCREEN_MIDDLE_Y,
				CENTER,
				CENTER,
				24,
				color(255)
			);
			self.appendDrawable(loadingLabel);

			const backgroundTexture = new SJ.SpriteSheetTexture2(
				vipClubSS,
				0,
				0,
				null,
				null,
				0,
				903,
				1600,
				900
			);
			self.appendDrawable(backgroundTexture);

			const backBtn = new BackToMenuBtn(168, 185);
			self.appendDrawable(backBtn);

			const vipInfoTexture = new SJ.SpriteSheetTexture2(
				vipClubSS,
				64,
				464,
				null,
				null,
				1139,
				515,
				770,
				388
			);
			self.appendDrawable(vipInfoTexture);

			const rankJumpsBuyDisplay = new SJ.RankJumpsBuyDisplay();
			self.appendDrawable(rankJumpsBuyDisplay);

			const vipAccountBuyDisplay = new SJ.VipAccountBuyDisplay([
				[7, 20],
				[14, 35],
				[30, 70],
				[60, 130],
				[90, 170],
			]);
			self.appendDrawable(vipAccountBuyDisplay);

			const moneyBuyDisplay = new SJ.MoneyBuyDisplay([
				[10000, 12],
				[25000, 25],
				[50000, 45],
				[100000, 85],
				[250000, 180],
				[500000, 325],
				[1000000, 550],
			]);
			self.appendDrawable(moneyBuyDisplay);

			SJ.updateVipBuyButtons = () => {
				vipAccountBuyDisplay.updateBuyButtons();
				moneyBuyDisplay.updateBuyButtons();
				rankJumpsBuyDisplay.updateBuyButtons();
			};

			const newspaperTexture = new SJ.SpriteSheetTexture2(
				vipClubSS,
				980,
				757,
				null,
				null,
				0,
				515,
				465,
				251
			);
			newspaperTexture.workingName = 'news';
			self.appendDrawable(newspaperTexture);

			const newspaperGoToBankBtn = new SJ.TextureButton(
				1023,
				800,
				null,
				null,
				new SJ.SpriteSheetTexture2(
					vipClubSS,
					0,
					0,
					null,
					null,
					1178,
					0,
					107,
					92
				)
			);
			newspaperGoToBankBtn.onMousePress = () => {
				SJ.ScreensManager.changeScreen(SJ.ScreensManager.screens.bank);
				SJ.mainMenuSoundContainer.play('bank');
			};

			self.appendDrawable(newspaperGoToBankBtn);

			self.appendDrawable(SJ.userDataBar);
			self.appendDrawable(SJ.registration);

			self.appendDrawable(new SJ.LoadingWindow());
		});

		SJ.ScreensManager.screens.bank = new SJ.Screen((self) => {
			const askForPayment = (userName, value, method) => {
				fbq('track', 'InitiateCheckout', {
					currency: 'PLN',
					value: 5,
				});

				fetch(
					`${SJ.APILink}shop/getPayData.php?userName=${userName}&value=${value}&method=${method}`
				)
					.then((res) => {
						return res.json();
					})
					.then((res) => {
						if (res !== 'ERR') {
							if (method != 'SMS') {
								const form = document.querySelector('#order');

								if (method === 'transfer')
									form.action = 'https://platnosc.hotpay.pl/';
								else if (method === 'psc')
									form.action = 'https://psc.hotpay.pl/';

								const priceInput = document.createElement('input');
								priceInput.type = 'hidden';
								priceInput.name = 'KWOTA';
								priceInput.value = res.KWOTA;
								form.appendChild(priceInput);

								const orderIdInput = document.createElement('input');
								orderIdInput.type = 'hidden';
								orderIdInput.name = 'ID_ZAMOWIENIA';
								orderIdInput.value = res.ID_ZAMOWIENIA;
								form.appendChild(orderIdInput);

								const secretInput = document.createElement('input');
								secretInput.type = 'hidden';
								secretInput.name = 'SEKRET';
								secretInput.value = res.SEKRET;
								form.appendChild(secretInput);

								const backWebsiteInput = document.createElement('input');
								backWebsiteInput.type = 'hidden';
								backWebsiteInput.name = 'ADRES_WWW';
								backWebsiteInput.value = window.location.href;
								form.appendChild(backWebsiteInput);

								form.submit();
							} else {
								smsForm.show(
									parseFloat(res.KWOTA),
									parseInt(res.NR_TEL),
									res.SEKRET
								);
							}
						} else {
							console.log("Something's gone wrong");
						}
					});
			};

			const loadingWindow = new SJ.LoadingWindow();

			const background = new SJ.SpriteSheetTexture(
				bankSS,
				0,
				0,
				null,
				null,
				0,
				953,
				1600,
				900
			);

			const smsForm = new SJ.SmsCodeCheckForm(bankSS);

			const agreement = new SJ.SpriteSheetTexture(
				bankSS,
				23,
				428,
				null,
				null,
				0,
				0,
				935,
				28
			);
			const specialOffer = new SJ.SpriteSheetTexture(
				bankSS,
				17.5,
				336.5,
				null,
				null,
				0,
				175,
				1021,
				185
			);

			const newspapper = new SJ.SpriteSheetTexture(
				bankSS,
				550,
				340,
				null,
				null,
				1021,
				175,
				445,
				223
			);

			const newspapperHover = new SJ.TextureButton(
				1416,
				726,
				null,
				null,
				new SJ.SpriteSheetTexture2(bankSS, 0, 0, null, null, 0, 55, 114, 85),
				null,
				null,
				null,
				() => {
					SJ.ScreensManager.changeScreen(SJ.ScreensManager.screens.vipClub);
					SJ.mainMenuSoundContainer.play('VIPClub');
				}
			);

			const bankIcon = new SJ.SpriteSheetTexture(
				bankSS,
				11,
				51.5,
				null,
				null,
				1432,
				55,
				254,
				120
			);
			const header = new SJ.SpriteSheetTexture(
				bankSS,
				141,
				57,
				null,
				null,
				114,
				55,
				1318,
				99
			);

			const offer1 = new SJ.SpriteSheetTexture(
				bankSS,
				17.5,
				120.5,
				null,
				null,
				1403,
				534,
				243,
				418
			);
			const offer2 = new SJ.SpriteSheetTexture(
				bankSS,
				146,
				120.5,
				null,
				null,
				1160,
				534,
				243,
				418
			);
			const offer3 = new SJ.SpriteSheetTexture(
				bankSS,
				275,
				120.5,
				null,
				null,
				917,
				534,
				243,
				418
			);
			const offer4 = new SJ.SpriteSheetTexture(
				bankSS,
				403.5,
				120.5,
				null,
				null,
				674,
				534,
				243,
				418
			);
			const offer5 = new SJ.SpriteSheetTexture(
				bankSS,
				532.5,
				120.5,
				null,
				null,
				431,
				534,
				243,
				418
			);
			const offer6 = new SJ.SpriteSheetTexture(
				bankSS,
				661,
				120.5,
				null,
				null,
				1646,
				534,
				243,
				418
			);

			const soon1 = new SJ.SpriteSheetTexture(
				bankSS,
				418.5,
				322,
				null,
				null,
				1483,
				0,
				183,
				38
			);
			const soon2 = new SJ.SpriteSheetTexture(
				bankSS,
				547.5,
				322,
				null,
				null,
				1483,
				0,
				183,
				38
			);
			const soon3 = new SJ.SpriteSheetTexture(
				bankSS,
				676,
				322,
				null,
				null,
				1483,
				0,
				183,
				38
			);

			const backBtn = new BackToMenuBtn(160, 184);

			const smsSoonHoverInfo = new SJ.SpriteSheetTexture2(
				bankSS,
				0,
				0,
				null,
				null,
				1666,
				0,
				151,
				55
			);
			smsSoonHoverInfo.hide();

			const paymentTransfer1 = new SJ.TextureButton(
				144.5,
				527.5,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				0,
				0
			);
			paymentTransfer1.setSize(117, 30);
			paymentTransfer1.onMousePress = () =>
				askForPayment(SJ.playerData.data['name'], 50, 'transfer');

			const paymentPSC1 = new SJ.TextureButton(
				144.5,
				570.5,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				0,
				0
			);
			paymentPSC1.setSize(117, 30);
			paymentPSC1.onMousePress = () =>
				askForPayment(SJ.playerData.data['name'], 50, 'psc');

			const paymentSMS1 = new SJ.TextureButton(
				193.5,
				613.5,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				0,
				0
			);
			paymentSMS1.setSize(63, 33);
			paymentSMS1.onMousePress = () =>
				askForPayment(SJ.playerData.data['name'], 50, 'SMS');

			const paymentTransfer2 = new SJ.TextureButton(
				400,
				526.5,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				0,
				0
			);
			paymentTransfer2.setSize(117, 30);
			paymentTransfer2.onMousePress = () =>
				askForPayment(SJ.playerData.data['name'], 150, 'transfer');

			const paymentPSC2 = new SJ.TextureButton(
				400,
				569.5,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				0,
				0
			);
			paymentPSC2.setSize(117, 30);
			paymentPSC2.onMousePress = () =>
				askForPayment(SJ.playerData.data['name'], 150, 'psc');

			const paymentSMS2 = new SJ.TextureButton(
				451,
				612.5,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				0,
				0
			);
			paymentSMS2.setSize(63, 33);
			paymentSMS2.onMousePress = () =>
				askForPayment(SJ.playerData.data['name'], 150, 'SMS');

			const paymentTransfer3 = new SJ.TextureButton(
				658,
				526.5,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				0,
				0
			);
			paymentTransfer3.setSize(117, 30);
			paymentTransfer3.onMousePress = () =>
				askForPayment(SJ.playerData.data['name'], 350, 'transfer');

			const paymentPSC3 = new SJ.TextureButton(
				658,
				569.5,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				0,
				0
			);
			paymentPSC3.setSize(117, 30);
			paymentPSC3.onMousePress = () =>
				askForPayment(SJ.playerData.data['name'], 350, 'psc');

			const paymentSMS3 = new SJ.TextureButton(
				709,
				612.5,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				0,
				0
			);
			paymentSMS3.setSize(63, 33);
			paymentSMS3.onMousePress = () => console.log('sms - offer 3');
			paymentSMS3.onMouseEnter = () => {
				smsSoonHoverInfo.x = paymentSMS3.x - 40;
				smsSoonHoverInfo.y = paymentSMS3.y + 30;
				smsSoonHoverInfo.show();
			};
			paymentSMS3.onMouseLeave = () => {
				smsSoonHoverInfo.hide();
			};

			const paymentTransfer4 = new SJ.TextureButton(
				915,
				526,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				0,
				0
			);
			paymentTransfer4.setSize(117, 30);
			paymentTransfer4.onMousePress = () =>
				askForPayment(SJ.playerData.data['name'], 600, 'transfer');

			const paymentPSC4 = new SJ.TextureButton(
				915,
				569,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				0,
				0
			);
			paymentPSC4.setSize(117, 30);
			paymentPSC4.onMousePress = () =>
				askForPayment(SJ.playerData.data['name'], 600, 'psc');

			const paymentSMS4 = new SJ.TextureButton(
				966,
				612,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				0,
				0
			);
			paymentSMS4.setSize(63, 33);
			paymentSMS4.onMousePress = () => console.log('sms - offer 4');
			paymentSMS4.onMouseEnter = () => {
				smsSoonHoverInfo.x = paymentSMS4.x - 40;
				smsSoonHoverInfo.y = paymentSMS4.y + 30;
				smsSoonHoverInfo.show();
			};
			paymentSMS4.onMouseLeave = () => {
				smsSoonHoverInfo.hide();
			};

			const paymentTransfer5 = new SJ.TextureButton(
				1173,
				527.5,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				0,
				0
			);
			paymentTransfer5.setSize(117, 30);
			paymentTransfer5.onMousePress = () =>
				askForPayment(SJ.playerData.data['name'], 1400, 'transfer');

			const paymentPSC5 = new SJ.TextureButton(
				1173,
				570.5,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				0,
				0
			);
			paymentPSC5.setSize(117, 30);
			paymentPSC5.onMousePress = () =>
				askForPayment(SJ.playerData.data['name'], 1400, 'psc');

			const paymentSMS5 = new SJ.TextureButton(
				1224,
				613.5,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				0,
				0
			);
			paymentSMS5.setSize(63, 33);
			paymentSMS5.onMousePress = () => console.log('sms - offer 5');
			paymentSMS5.onMouseEnter = () => {
				smsSoonHoverInfo.x = paymentSMS5.x - 40;
				smsSoonHoverInfo.y = paymentSMS5.y + 30;
				smsSoonHoverInfo.show();
			};
			paymentSMS5.onMouseLeave = () => {
				smsSoonHoverInfo.hide();
			};

			const paymentTransfer6 = new SJ.TextureButton(
				1430.5,
				526.5,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				0,
				0
			);
			paymentTransfer6.setSize(117, 30);
			paymentTransfer6.onMousePress = () =>
				askForPayment(SJ.playerData.data['name'], 3250, 'transfer');

			const paymentPSC6 = new SJ.TextureButton(
				1430.5,
				569.5,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				0,
				0
			);
			paymentPSC6.setSize(117, 30);
			paymentPSC6.onMousePress = () =>
				askForPayment(SJ.playerData.data['name'], 3250, 'transfer');

			const paymentSMS6 = new SJ.TextureButton(
				1481,
				613,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				0,
				0
			);
			paymentSMS6.setSize(63, 33);
			paymentSMS6.onMousePress = () => console.log('sms - offer 6');
			paymentSMS6.onMouseEnter = () => {
				smsSoonHoverInfo.x = paymentSMS6.x - 40;
				smsSoonHoverInfo.y = paymentSMS6.y + 30;
				smsSoonHoverInfo.show();
			};
			paymentSMS6.onMouseLeave = () => {
				smsSoonHoverInfo.hide();
			};

			const paymentTransferSpecial = new SJ.TextureButton(
				737,
				803,
				null,
				new SJ.SpriteSheetTexture2(bankSS, 0, 0, null, null, 1052, 0, 117, 30)
			);
			paymentTransferSpecial.onMousePress = () =>
				askForPayment(SJ.playerData.data['name'], 7000, 'transfer');

			const paymentPSCSpecial = new SJ.TextureButton(
				867,
				803,
				null,
				new SJ.SpriteSheetTexture2(bankSS, 0, 0, null, null, 935, 0, 117, 30)
			);
			paymentPSCSpecial.onMousePress = () =>
				askForPayment(SJ.playerData.data['name'], 7000, 'psc');

			self.appendDrawable(background);

			self.appendDrawable(agreement);
			self.appendDrawable(specialOffer);
			self.appendDrawable(newspapper);
			self.appendDrawable(newspapperHover);
			self.appendDrawable(bankIcon);
			self.appendDrawable(header);

			self.appendDrawable(offer1);
			self.appendDrawable(offer2);
			self.appendDrawable(offer3);
			self.appendDrawable(offer4);
			self.appendDrawable(offer5);
			self.appendDrawable(offer6);

			self.appendDrawable(soon1);
			self.appendDrawable(soon2);
			self.appendDrawable(soon3);

			self.appendDrawable(backBtn);
			self.appendDrawable(paymentTransfer1);
			self.appendDrawable(paymentPSC1);
			self.appendDrawable(paymentSMS1);
			self.appendDrawable(paymentTransfer2);
			self.appendDrawable(paymentPSC2);
			self.appendDrawable(paymentSMS2);
			self.appendDrawable(paymentTransfer3);
			self.appendDrawable(paymentPSC3);
			self.appendDrawable(paymentSMS3);
			self.appendDrawable(paymentTransfer4);
			self.appendDrawable(paymentPSC4);
			self.appendDrawable(paymentSMS4);
			self.appendDrawable(paymentTransfer5);
			self.appendDrawable(paymentPSC5);
			self.appendDrawable(paymentSMS5);
			self.appendDrawable(paymentTransfer6);
			self.appendDrawable(paymentPSC6);
			self.appendDrawable(paymentSMS6);
			self.appendDrawable(paymentTransferSpecial);
			self.appendDrawable(paymentPSCSpecial);

			self.appendDrawable(smsForm);

			self.appendDrawable(smsSoonHoverInfo);

			self.appendDrawable(SJ.userDataBar);
			self.appendDrawable(SJ.registration);

			self.appendDrawable(loadingWindow);
		});

		SJ.ScreensManager._isSetupped = true;
	};

	SJ.ScreensManager.currentScreen = {
		draw: () => {
			console.log('No Screen selected!');
		},
	};

	SJ.ScreensManager.changeScreen = (screen, atribute = null) => {
		// document.body.style.cursor = 'default';

		SJ.ScreensManager.currentScreen = screen;

		// SJ.ScreensManager.currentScreen._drawable.forEach(e => {
		//   if(e.onScreenChange)e.onScreenChange();
		// });

		SJ.ScreensManager.currentScreen.onScreenChange(atribute);
	};

	SJ.ScreensManager.draw = () => {
		SJ.ScreensManager.currentScreen.draw();
	};

	SJ.ScreensManager.onMouseMove = () => {
		return SJ.ScreensManager.currentScreen.onMouseMove();
	};

	SJ.ScreensManager.onMousePress = () => {
		return SJ.ScreensManager.currentScreen.onMousePress();
	};

	SJ.ScreensManager.onMouseRelease = () => {
		return SJ.ScreensManager.currentScreen.onMouseRelease();
	};

	SJ.ScreensManager.onMouseWheelMove = (delta) => {
		return SJ.ScreensManager.currentScreen.onMouseWheelMove(delta);
	};
});
